function archiveRewardsReady(callback) {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", callback);
    return;
  }

  callback();
}

window.archiveRewardsShowToast = window.archiveRewardsShowToast || (() => {
  let toast;
  let toastTimer;

  function createToast() {
    const element = document.createElement("div");

    element.className = "archive-rewards-toast";
    element.setAttribute("role", "status");
    element.setAttribute("aria-live", "polite");
    element.innerHTML = `
      <div class="archive-rewards-toast__icon" aria-hidden="true">
        <svg viewBox="0 0 24 24">
          <path data-toast-icon d="M5 12.5l4 4L19 7"></path>
        </svg>
      </div>
      <div>
        <strong data-toast-title></strong>
        <span data-toast-message></span>
      </div>
    `;

    document.body.appendChild(element);

    return element;
  }

  return function showToast({ title, message, tone = "success" }) {
    if (!toast) {
      toast = createToast();
    }

    const icon = toast.querySelector("[data-toast-icon]");
    const titleElement = toast.querySelector("[data-toast-title]");
    const messageElement = toast.querySelector("[data-toast-message]");

    toast.classList.toggle("archive-rewards-toast--error", tone === "error");

    if (icon) {
      icon.setAttribute("d", tone === "error" ? "M12 7v6m0 4h.01" : "M5 12.5l4 4L19 7");
    }

    if (titleElement) {
      titleElement.textContent = title;
    }

    if (messageElement) {
      messageElement.textContent = message;
    }

    window.clearTimeout(toastTimer);
    toast.classList.remove("is-visible");

    window.requestAnimationFrame(() => {
      toast.classList.add("is-visible");
    });

    toastTimer = window.setTimeout(() => {
      toast.classList.remove("is-visible");
    }, 3000);
  };
})();

archiveRewardsReady(() => {
  const customerConfig = window.archiveRewardsCustomer || {};
  const endpoint = customerConfig.rewardProfileEndpoint;
  const rewardsEndpoint = endpoint ? endpoint.replace(/\/$/, "") : "";
  const generateEndpoint = rewardsEndpoint ? `${rewardsEndpoint}/voucher` : "";
  const convertEndpoint = rewardsEndpoint ? `${rewardsEndpoint}/voucher/convert-to-points` : "";
  const newsletterEndpoint = customerConfig.newsletterEndpoint;
  const profileLoadEndpoint = customerConfig.profileLoadEndpoint;
  const profileSaveEndpoint = customerConfig.profileSaveEndpoint;
  const customerId = customerConfig.customerId;
  const showToast = window.archiveRewardsShowToast;
  const numberFormatter = new Intl.NumberFormat("en-AU");
  const currencyFormatter = new Intl.NumberFormat("en-AU", {
    style: "currency",
    currency: "AUD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
  const profileCompletionReturnKey = "twaArchiveProfileCompletionReturn";
  let shouldShowProfileCompletionConfirmation = false;

  try {
    shouldShowProfileCompletionConfirmation =
      window.sessionStorage.getItem(profileCompletionReturnKey) === "1";

    if (shouldShowProfileCompletionConfirmation) {
      window.sessionStorage.removeItem(profileCompletionReturnKey);
    }
  } catch (error) {
    console.warn("Unable to read Archive Profile completion return state.", error);
  }

  const summaryElements = {
    balancePoints: document.querySelector("[data-rewards-balance-points]"),
    balanceValue: document.querySelector("[data-rewards-balance-value]"),
    earnedPoints: document.querySelector("[data-rewards-earned-points]"),
    earnedText: document.querySelector("[data-rewards-earned-text]"),
    redeemedPoints: document.querySelector("[data-rewards-redeemed-points]"),
    redeemedValue: document.querySelector("[data-rewards-redeemed-value]"),
    voucherCode: document.querySelector("[data-rewards-voucher-code]"),
    voucherCodeText: document.querySelector("[data-rewards-voucher-code-text]"),
    voucherSummary: document.querySelector("[data-rewards-voucher-summary]"),
    voucherEmpty: document.querySelector("[data-rewards-voucher-empty]"),
    voucherEmptyText: document.querySelector("[data-rewards-voucher-empty-text]"),
    voucherActions: document.querySelector("[data-rewards-voucher-actions]"),
    convertButton: document.querySelector("[data-rewards-convert-voucher]"),
    topInfo: document.querySelector("[data-rewards-top-info]"),
    bottomInfo: document.querySelector("[data-rewards-bottom-info]"),
    progress: document.querySelector("[data-rewards-progress]"),
    progressTitle: document.querySelector("[data-rewards-progress-title]"),
    progressCopy: document.querySelector("[data-rewards-progress-copy]"),
    progressMeter: document.querySelector("[data-rewards-progress-meter]"),
    progressCurrent: document.querySelector("[data-rewards-progress-current]"),
    progressTarget: document.querySelector("[data-rewards-progress-target]"),
    progressBar: document.querySelector("[data-rewards-progress-bar]"),
    progressRemaining: document.querySelector("[data-rewards-progress-remaining]"),
    profileCompletionConfirmation: document.querySelector("[data-rewards-profile-confirmation]"),
    profileCompletionPanel: document.querySelector("[data-rewards-profile-completion-panel]"),
    profileCompletionConfirmationText: document.querySelector("[data-rewards-profile-confirmation-text]"),
    progressComplete: document.querySelector("[data-rewards-progress-complete]"),
    progressWaysTitle: document.querySelector("[data-rewards-progress-ways-title]"),
    newsletter: document.querySelector("[data-rewards-newsletter]"),
    newsletterCheckbox: document.querySelector("[data-rewards-newsletter-checkbox]"),
    newsletterNote: document.querySelector("[data-rewards-newsletter-note]"),
    newsletterTitleDefault: document.querySelector("[data-newsletter-title-default]"),
    newsletterTitleSubscribed: document.querySelector("[data-newsletter-title-subscribed]"),
    newsletterAwardedLabel: document.querySelector("[data-newsletter-awarded-label]"),
    newsletterAwardedSuffix: document.querySelector("[data-newsletter-awarded-suffix]"),
    newsletterBadgePoints: document.querySelector("[data-newsletter-badge-points]"),
    newsletterProgressPoints: document.querySelector("[data-newsletter-progress-points]"),
    giftGrid: document.querySelector("[data-gift-journey-grid]"),
    giftPreviousButton: document.querySelector(".archive-gift-vouchers__arrow--prev"),
    giftNextButton: document.querySelector(".archive-gift-vouchers__arrow--next"),
    milestoneSection: document.querySelector("[data-milestone-rewards]"),
    milestoneCurrent: document.querySelector("[data-milestone-current]"),
    milestoneTarget: document.querySelector("[data-milestone-target]"),
    milestoneProgressBar: document.querySelector("[data-milestone-progress-bar]"),
    milestoneProgressPercent: document.querySelector("[data-milestone-progress-percent]"),
    milestoneRemaining: document.querySelector("[data-milestone-remaining]"),
    milestoneSteps: document.querySelector("[data-milestone-steps]"),
    milestoneSubcopy: document.querySelector("[data-milestone-progress-subcopy]"),
    voucherOptionsContainer: document.querySelector("[data-rewards-voucher-options]"),
    generateButtons: Array.from(document.querySelectorAll("[data-rewards-generate-voucher]"))
  };
  let isConvertingVoucher = false;
  let isGeneratingVoucher = false;
  let isSubscribingNewsletter = false;
  let isSavingBirthday = false;
  let giftCarouselPage = 1;
  let confirmDialog;
  let confirmResolve;
  let birthdayDialog;
  let giftVouchersInfoDialog;
  let milestoneRewardsInfoDialog;
  let lastFocusedElement;

  function centsToPoints(value) {
    return Number.isFinite(Number(value)) ? Number(value) : 0;
  }

  function formatPoints(value) {
    return numberFormatter.format(centsToPoints(value));
  }

  function formatCurrencyFromCents(value) {
    const cents = Number.isFinite(Number(value)) ? Number(value) : 0;

    return currencyFormatter.format(cents / 100);
  }

  function formatVoucherAmount(amountCents) {
    return currencyFormatter.format(amountCents / 100);
  }

  function formatWholeCurrency(amountCents) {
    return formatCurrencyFromCents(amountCents).replace(".00", "");
  }

  function markSectionLoaded(element, loadingClass, loadedClass) {
    if (!element) {
      return;
    }

    element.classList.remove(loadingClass);

    if (loadedClass) {
      element.classList.add(loadedClass);
    }
  }

  function getNewsletterRewardPoints(status) {
    const rewardContribution = Number(
      status?.rewardContributionCents ??
      status?.rewardContribution ??
      status?.rewardPoints ??
      status?.rewardAmountCents ??
      status?.rewardAmount
    );

    return Number.isFinite(rewardContribution) && rewardContribution > 0
      ? rewardContribution
      : 500;
  }

  function getNewsletterRewardLabel(status) {
    return `${formatPoints(getNewsletterRewardPoints(status))} Reward Points`;
  }

  // Subscribed, but no points were added because the $100 earning threshold had been reached.
  function isNewsletterRewardThresholdBlocked(status) {
    return Boolean(status?.isSubscribed && status?.earningThresholdBlocked);
  }

  function updateNewsletterRewardText(status) {
    const thresholdBlocked = isNewsletterRewardThresholdBlocked(status);
    const rewardPoints = thresholdBlocked ? 0 : getNewsletterRewardPoints(status);
    const rewardLabel = getNewsletterRewardLabel(status);

    if (summaryElements.newsletterTitleDefault) {
      summaryElements.newsletterTitleDefault.textContent = `Subscribe to receive ${rewardLabel} when eligible!`;
    }

    if (summaryElements.newsletterTitleSubscribed) {
      summaryElements.newsletterTitleSubscribed.textContent = thresholdBlocked
        ? "You're subscribed to our newsletter!"
        : `You're already earning ${rewardLabel}!`;
    }

    if (summaryElements.newsletterAwardedLabel) {
      summaryElements.newsletterAwardedLabel.textContent = thresholdBlocked ? "No Reward Points" : rewardLabel;
    }

    if (summaryElements.newsletterAwardedSuffix) {
      summaryElements.newsletterAwardedSuffix.textContent = thresholdBlocked
        ? "were added because your Rewards balance had reached the $100 earning threshold."
        : "have been awarded to your account.";
    }

    if (summaryElements.newsletterBadgePoints) {
      summaryElements.newsletterBadgePoints.textContent = `+${formatPoints(rewardPoints)}`;
    }

    if (summaryElements.newsletterProgressPoints) {
      summaryElements.newsletterProgressPoints.textContent = `+${formatPoints(rewardPoints)}`;
    }
  }

  function getCustomerLoginUrl() {
    return `/customer_authentication/login?return_to=${encodeURIComponent(window.location.pathname + window.location.search)}`;
  }

  function setPoints(element, value) {
    if (!element) {
      return;
    }

    element.classList.remove("archive-rewards-card__loading");
    element.innerHTML = `${formatPoints(value)} <small>Points</small>`;
  }

  function setCopyCode(control, code) {
    if (!control) {
      return;
    }

    control.dataset.copyCode = code;
    control.setAttribute("aria-label", `Copy reward voucher code ${code}`);
  }

  function setSummaryError() {
    setPoints(summaryElements.balancePoints, 0);
    setPoints(summaryElements.earnedPoints, 0);
    setPoints(summaryElements.redeemedPoints, 0);

    if (summaryElements.balanceValue) {
      summaryElements.balanceValue.textContent = "Unable to load rewards.";
    }

    if (summaryElements.earnedText) {
      summaryElements.earnedText.textContent = "Unable to load rewards.";
    }

    if (summaryElements.redeemedValue) {
      summaryElements.redeemedValue.textContent = "Unable to load rewards.";
    }

    showEmptyVoucher("Unable to load voucher.");
    updateVoucherGenerationState(null);
  }

  function showEmptyVoucher(message = "Generate a voucher with your points.") {
    if (summaryElements.voucherCode) {
      summaryElements.voucherCode.hidden = true;
      summaryElements.voucherCode.classList.remove("archive-rewards-card__loading");
      summaryElements.voucherCode.removeAttribute("data-copy-code");
      summaryElements.voucherCode.removeAttribute("aria-label");
    }

    if (summaryElements.voucherSummary) {
      summaryElements.voucherSummary.hidden = true;
    }

    window.ArchiveRewardsVoucherMinimum?.render(document, null, null);

    if (summaryElements.voucherActions) {
      summaryElements.voucherActions.hidden = true;
    }

    if (summaryElements.voucherEmpty) {
      summaryElements.voucherEmpty.hidden = false;
    }

    if (summaryElements.voucherEmptyText) {
      summaryElements.voucherEmptyText.hidden = false;
      summaryElements.voucherEmptyText.textContent = message;
    }
  }

  function showActiveVoucher(profile) {
    const code = profile.activeVoucherCode;
    const amountCents = profile.activeVoucherAmountCents;

    if (!code) {
      showEmptyVoucher();
      return;
    }

    if (summaryElements.voucherEmpty) {
      summaryElements.voucherEmpty.hidden = true;
    }

    if (summaryElements.voucherEmptyText) {
      summaryElements.voucherEmptyText.hidden = true;
    }

    if (summaryElements.voucherCode) {
      summaryElements.voucherCode.hidden = false;
      summaryElements.voucherCode.classList.remove("archive-rewards-card__loading");
      setCopyCode(summaryElements.voucherCode, code);
    }

    if (summaryElements.voucherCodeText) {
      summaryElements.voucherCodeText.textContent = code;
    }

    if (summaryElements.voucherSummary) {
      summaryElements.voucherSummary.hidden = false;
      summaryElements.voucherSummary.innerHTML = `${formatCurrencyFromCents(amountCents)} value <b>&bull;</b> From your points`;
    }

    // Minimum eligible order row (points-funded Reward Vouchers only; see archive-rewards-voucher-minimum.js).
    window.ArchiveRewardsVoucherMinimum?.render(document, code, amountCents);

    if (summaryElements.voucherActions) {
      summaryElements.voucherActions.hidden = false;
      summaryElements.voucherActions.querySelectorAll("[data-copy-code]").forEach(control => {
        setCopyCode(control, code);
      });
    }

    if (summaryElements.convertButton) {
      summaryElements.convertButton.disabled = false;
      summaryElements.convertButton.setAttribute("aria-disabled", "false");
      summaryElements.convertButton.removeAttribute("aria-busy");
    }
  }

  function escapeHtml(value) {
    return String(value ?? "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function giftIconSvg() {
    return `
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <rect x="4" y="9" width="16" height="11"></rect>
        <path d="M12 9v11"></path>
        <path d="M4 13h16"></path>
        <path d="M12 9c-3 0-4-2-3-3.5S12 4 12 7"></path>
        <path d="M12 9c3 0 4-2 3-3.5S12 4 12 7"></path>
      </svg>
    `;
  }

  function copyIconSvg() {
    return `
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <rect x="9" y="9" width="10" height="10" rx="1"></rect>
        <rect x="5" y="5" width="10" height="10" rx="1"></rect>
      </svg>
    `;
  }

  function lockIconSvg() {
    return `
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <rect x="7" y="10" width="10" height="9" rx="1.5"></rect>
        <path d="M9 10V8a3 3 0 016 0v2"></path>
      </svg>
    `;
  }

  function renderVoucherOptions(profile) {
    if (!summaryElements.voucherOptionsContainer) {
      return;
    }

    const options = Array.isArray(profile?.redemption?.voucherOptions)
      ? profile.redemption.voucherOptions
      : [];

    markSectionLoaded(
      summaryElements.voucherOptionsContainer,
      "archive-rewards-vouchers--loading",
      "archive-rewards-vouchers--loaded"
    );

    summaryElements.voucherOptionsContainer.innerHTML = options
      .map((option, index) => {
        const amountCents = Number(option.amountCents) || 0;
        const label = option.displayText || formatWholeCurrency(amountCents);
        const points = formatPoints(amountCents);
        const isBestOption = index === 0;

        return `
          <article class="archive-voucher-card" data-rewards-voucher-card>
            <span data-rewards-best-badge ${isBestOption ? "" : "hidden"}>Best Option</span>
            <strong>${escapeHtml(label)} <small>OFF</small></strong>
            <p>${points} Points</p>
            ${customerConfig.isAuthenticated
              ? `<button type="button" data-rewards-generate-voucher data-rewards-voucher-amount-cents="${amountCents}" disabled aria-disabled="true">Generate Voucher</button>`
              : `<button type="button" disabled aria-disabled="true">
                  ${lockIconSvg()}
                  Sign in required
                </button>`}
          </article>
        `;
      })
      .join("");

    summaryElements.generateButtons = Array.from(
      summaryElements.voucherOptionsContainer.querySelectorAll("[data-rewards-generate-voucher]")
    );
  }

  function getGiftState(card) {
    const state = card?.state;

    if (typeof state === "number") {
      return {
        1: "activeVoucher",
        2: "birthdayMissing",
        3: "upcoming",
        4: "comingSoon",
        5: "placeholder",
        6: "promotion",
        7: "readyToGenerate",
        8: "claimWindow",
        9: "voucherGenerated",
        10: "opportunityMissed"
      }[state] || "";
    }

    const normalized = String(state || "")
      .replace(/[\s_-]/g, "")
      .toLowerCase();

    return {
      activevoucher: "activeVoucher",
      birthdaymissing: "birthdayMissing",
      missingbirthday: "birthdayMissing",
      upcoming: "upcoming",
      comingsoon: "comingSoon",
      placeholder: "placeholder",
      promotion: "promotion",
      activepromotion: "promotion",
      readytogenerate: "readyToGenerate",
      ready: "readyToGenerate",
      claimwindow: "claimWindow",
      vouchergenerated: "voucherGenerated",
      generated: "voucherGenerated",
      opportunitymissed: "opportunityMissed",
      missed: "opportunityMissed"
    }[normalized] || String(state || "")
      .replace(/^[A-Z]/, value => value.toLowerCase());
  }

  function renderGiftCardTop(title) {
    return `
      <div class="archive-gift-voucher__top">
        <h3>${escapeHtml(title)}</h3>
        ${giftIconSvg()}
      </div>
    `;
  }

  function getGiftVoucherType(voucher) {
    const type = voucher?.voucherType ?? voucher?.type;

    if (typeof type === "number") {
      return type;
    }

    return {
      reward: 1,
      birthday: 2,
      anniversary: 3,
      promotion: 4,
      milestone: 5,
      goodwill: 6
    }[String(type || "").toLowerCase()];
  }

  function getGiftVoucherTitle(voucher) {
    return voucher?.title || {
      2: "Birthday Gift",
      3: "Anniversary Gift",
      4: "Promotional Gift",
      5: "Collector Milestone",
      6: "Goodwill Gift"
    }[getGiftVoucherType(voucher)] || "Gift Voucher";
  }

  function getGiftCardType(card) {
    const type = card?.type;

    if (typeof type === "number") {
      return {
        2: "birthday",
        3: "anniversary",
        4: "promotion",
        5: "milestone",
        6: "goodwill"
      }[type] || "gift";
    }

    const normalizedType = String(type || "")
      .replace(/[\s_-]/g, "")
      .toLowerCase();

    if (normalizedType) {
      return {
        birthday: "birthday",
        anniversary: "anniversary",
        milestone: "milestone",
        promotion: "promotion",
        goodwill: "goodwill",
        placeholder: "gift"
      }[normalizedType] || normalizedType;
    }

    if (card?.voucher) {
      return {
        2: "birthday",
        3: "anniversary",
        4: "promotion",
        5: "milestone",
        6: "goodwill"
      }[getGiftVoucherType(card.voucher)] || "gift";
    }

    const key = String(card?.key || "").toLowerCase();
    const title = String(card?.title || "").toLowerCase();

    if (key.includes("birthday") || title.includes("birthday")) {
      return "birthday";
    }

    if (key.includes("anniversary") || title.includes("anniversary")) {
      return "anniversary";
    }

    if (key.includes("milestone") || title.includes("milestone")) {
      return "milestone";
    }

    if (key.includes("promotion") || title.includes("promotion")) {
      return "promotion";
    }

    return "gift";
  }

  function formatCompactNumber(value) {
    const number = Number(value);

    if (!Number.isFinite(number)) {
      return "";
    }

    return numberFormatter.format(number);
  }

  function formatGiftDate(value) {
    if (!value) {
      return "";
    }

    const date = new Date(value);

    if (Number.isNaN(date.getTime())) {
      return String(value);
    }

    return date.toLocaleDateString("en-AU", {
      day: "numeric",
      month: "long",
      year: "numeric"
    });
  }

  function getGiftRewardDisplay(card, voucher = card?.voucher) {
    const percentage = card?.cashbackPercentage ?? card?.percentage;
    const amount = card?.rewardAmount ?? card?.amount;
    const label = card?.rewardLabel || card?.subtitle;

    if (percentage !== undefined && percentage !== null) {
      return {
        amount: `${formatCompactNumber(percentage)}%`,
        label: label || ""
      };
    }

    if (amount !== undefined && amount !== null) {
      return {
        amount: `$${formatCompactNumber(amount)}`,
        label: label || getVoucherDisplayLabel(card)
      };
    }

    if (voucher?.amountCents !== undefined && voucher?.amountCents !== null) {
      return {
        amount: formatCurrencyFromCents(voucher.amountCents).replace(".00", ""),
        label: label || getVoucherDisplayLabel(card)
      };
    }

    return {
      amount: "",
      label: label || ""
    };
  }

  function getGiftAction(card, fallbackLabel = "", fallbackUrl = "") {
    const cta = card?.cta || {};

    return {
      label: card?.actionLabel || card?.ctaText || cta.text || fallbackLabel,
      url: card?.actionUrl || card?.ctaUrl || cta.url || fallbackUrl
    };
  }

  function getGiftBadge(card) {
    return card?.badge || card?.voucher?.ribbonBadge || "";
  }

  function renderGiftBadge(card) {
    const badge = getGiftBadge(card);

    return badge
      ? `<span class="archive-gift-voucher__badge">${escapeHtml(badge)}</span>`
      : "";
  }

  function renderGiftDivider() {
    return `
      <div class="archive-gift-voucher__divider" aria-hidden="true">
        <span></span>
      </div>
    `;
  }

  function getVoucherDisplayLabel(card) {
    const title = String(card?.title || card?.voucher?.title || "Gift Voucher");

    if (/voucher/i.test(title)) {
      return title;
    }

    return `${title} Voucher`;
  }

  function renderGiftArt(card) {
    return "";
  }

  function renderActiveGiftCard(card) {
    const voucher = card.voucher || {};
    const code = escapeHtml(voucher.voucherCode);
    const reward = getGiftRewardDisplay(card, voucher);
    const expiresIn = Number.isFinite(Number(voucher.expiresInDays))
      ? `Expires in ${Number(voucher.expiresInDays)} days`
      : "Gift voucher active";
    const expiresAt = voucher.expiresAtDisplay || "";

    return `
      <article class="archive-gift-voucher archive-gift-voucher--journey archive-gift-voucher--${escapeHtml(getGiftCardType(card))}">
        ${renderGiftCardTop(card.title)}
        ${renderGiftBadge(card)}
        <div class="archive-gift-voucher__reward">
          <strong>${escapeHtml(reward.amount)}</strong>
          <span>${escapeHtml(reward.label)}</span>
        </div>
        ${renderGiftDivider()}
        <div class="archive-gift-voucher__code" role="button" tabindex="0" data-copy-code="${code}" aria-label="Copy gift voucher code ${code}">
          ${code}
          ${copyIconSvg()}
        </div>
        <div class="archive-gift-voucher__expiry">${escapeHtml(expiresIn)}</div>
        <div class="archive-gift-voucher__date">${escapeHtml(expiresAt)}</div>
        <span class="archive-gift-voucher__status">Active</span>
        <button type="button" data-copy-code="${code}">
          ${copyIconSvg()}
          Copy Code
        </button>
        ${renderGiftArt(card)}
      </article>
    `;
  }

  function renderGeneratedGiftCard(card) {
    const voucher = card.voucher || {};
    const code = escapeHtml(voucher.voucherCode);
    const reward = getGiftRewardDisplay(card, voucher);
    const expiresAt = voucher.expiresAtDisplay || "";
    const expiresIn = Number.isFinite(Number(voucher.expiresInDays))
      ? `${Number(voucher.expiresInDays)} days remaining`
      : "";

    return `
      <article class="archive-gift-voucher archive-gift-voucher--journey archive-gift-voucher--generated archive-gift-voucher--${escapeHtml(getGiftCardType(card))}">
        ${renderGiftCardTop(card.title)}
        ${renderGiftBadge(card)}
        <div class="archive-gift-voucher__reward">
          <span>Complimentary Voucher Issued</span>
          <strong>${escapeHtml(reward.amount)}</strong>
        </div>
        ${renderGiftDivider()}
        <div class="archive-gift-voucher__code" role="button" tabindex="0" data-copy-code="${code}" aria-label="Copy gift voucher code ${code}">
          ${code}
          ${copyIconSvg()}
        </div>
        <div class="archive-gift-voucher__expiry archive-gift-voucher__expiry--strong">Expires</div>
        <div class="archive-gift-voucher__date">${escapeHtml(expiresAt)}</div>
        ${expiresIn ? `<div class="archive-gift-voucher__expiry">${escapeHtml(expiresIn)}</div>` : ""}
        ${renderGiftArt(card)}
      </article>
    `;
  }

  function renderBirthdayMissingCard(card) {
    const action = getGiftAction(card, "Add Birthday", "/pages/archive-persona");
    const isBirthday = getGiftCardType(card) === "birthday";
    const rewardAmount = card.rewardAmount !== undefined && card.rewardAmount !== null
      ? `$${formatCompactNumber(card.rewardAmount)}`
      : "";
    const secondaryText = isBirthday
      ? `Add your birthday to receive a complimentary ${rewardAmount ? `<strong>${escapeHtml(rewardAmount)}</strong> ` : ""}birthday voucher every year.`
      : escapeHtml(card.secondaryText);

    return `
      <article class="archive-gift-voucher archive-gift-voucher--journey archive-gift-voucher--${escapeHtml(getGiftCardType(card))}">
        ${renderGiftCardTop(card.title)}
        ${renderGiftBadge(card)}
        <div class="archive-gift-voucher__reward archive-gift-voucher__reward--message">
          <strong>${escapeHtml(card.primaryText)}</strong>
          <span>${secondaryText}</span>
        </div>
        <button class="archive-gift-voucher__action" type="button" data-rewards-add-birthday data-fallback-url="${escapeHtml(action.url)}">
          ${giftIconSvg()}
          ${escapeHtml(action.label)}
        </button>
        ${renderGiftArt(card)}
      </article>
    `;
  }

  function renderUpcomingGiftCard(card) {
    const cardType = getGiftCardType(card);

    return `
      <article class="archive-gift-voucher archive-gift-voucher--journey archive-gift-voucher--upcoming archive-gift-voucher--${escapeHtml(cardType)}">
        ${renderGiftCardTop(card.title)}
        ${renderGiftBadge(card)}
        <div class="archive-gift-voucher__reward">
          <span>${escapeHtml(card.primaryText)}</span>
          <strong>${Number.isFinite(Number(card.daysUntil)) ? `${Number(card.daysUntil)} days` : escapeHtml(card.secondaryText)}</strong>
        </div>
        ${renderGiftDivider()}
        ${card.secondaryText && Number.isFinite(Number(card.daysUntil))
          ? `<div class="archive-gift-voucher__expiry">${escapeHtml(card.secondaryText)}</div>`
          : ""}
        <div class="archive-gift-voucher__date">
          ${escapeHtml(card.label)}
          ${card.displayDate ? `<span>${escapeHtml(card.displayDate)}</span>` : ""}
        </div>
        ${renderGiftArt(card)}
      </article>
    `;
  }

  function renderGiftActionCard(card) {
    return `
      <article class="archive-gift-voucher archive-gift-voucher--journey archive-gift-voucher--ready archive-gift-voucher--${escapeHtml(getGiftCardType(card))}">
        ${renderGiftCardTop(card.title)}
        ${renderGiftBadge(card)}
        <div class="archive-gift-voucher__reward archive-gift-voucher__reward--message">
          <strong>${escapeHtml(card.primaryText)}</strong>
          <span>${escapeHtml(card.secondaryText)}</span>
        </div>
        ${renderGiftDivider()}
        ${Number.isFinite(Number(card.remainingClaimDays))
          ? `<div class="archive-gift-voucher__expiry archive-gift-voucher__expiry--strong">${Number(card.remainingClaimDays)} days remaining in claim window</div>`
          : ""}
        <div class="archive-gift-voucher__date">
          ${escapeHtml(card.label || "")}
          ${card.displayDate ? `<span>${escapeHtml(card.displayDate)}</span>` : ""}
        </div>
        ${renderGiftArt(card)}
      </article>
    `;
  }

  function renderGiftMissedCard(card) {
    return `
      <article class="archive-gift-voucher archive-gift-voucher--journey archive-gift-voucher--missed archive-gift-voucher--${escapeHtml(getGiftCardType(card))}">
        ${renderGiftCardTop(card.title)}
        ${renderGiftBadge(card)}
        <div class="archive-gift-voucher__reward archive-gift-voucher__reward--message">
          <strong>${escapeHtml(card.primaryText)}</strong>
          <span>${escapeHtml(card.secondaryText)}</span>
        </div>
        ${renderGiftDivider()}
        <div class="archive-gift-voucher__date">
          ${escapeHtml(card.label || "")}
          ${card.displayDate ? `<span>${escapeHtml(card.displayDate)}</span>` : ""}
        </div>
        ${renderGiftArt(card)}
      </article>
    `;
  }

  function renderComingSoonGiftCard(card) {
    const isMilestone = getGiftCardType(card) === "milestone";
    const title = isMilestone
      ? "Unlock More Along the Way"
      : card.primaryText;
    const supportingText = isMilestone
      ? "Keep building your Archive journey to unlock additional gift vouchers."
      : card.secondaryText || "More rewards unlock as your Archive journey grows.";

    return `
      <article class="archive-gift-voucher archive-gift-voucher--journey archive-gift-voucher--${escapeHtml(getGiftCardType(card))}">
        ${renderGiftCardTop(card.title)}
        ${renderGiftBadge(card)}
        <div class="archive-gift-voucher__reward archive-gift-voucher__reward--message">
          <strong>${escapeHtml(title)}</strong>
          <span>${escapeHtml(supportingText)}</span>
        </div>
        ${isMilestone
          ? `<p class="archive-gift-voucher__quote">The journey is as rewarding as the collection itself.</p>`
          : ""}
        ${renderGiftArt(card)}
      </article>
    `;
  }

  function renderPromotionGiftCard(card) {
    const reward = getGiftRewardDisplay(card);
    const action = getGiftAction(card);
    const dateText = formatGiftDate(card.promotionEndDate || card.endDate || card.endsAt);
    const description = card.description || card.primaryText || "";
    const secondaryText = card.secondaryText || card.displayDate || (
      dateText ? `Before ${dateText}` : ""
    );

    return `
      <article class="archive-gift-voucher archive-gift-voucher--journey archive-gift-voucher--${escapeHtml(getGiftCardType(card))}">
        ${renderGiftCardTop(card.title)}
        ${renderGiftBadge(card)}
        <div class="archive-gift-voucher__reward">
          <strong>${escapeHtml(reward.amount)}</strong>
          <span>${escapeHtml(reward.label)}</span>
        </div>
        ${renderGiftDivider()}
        <div class="archive-gift-voucher__expiry archive-gift-voucher__expiry--strong">
          ${card.descriptionHtml || escapeHtml(description)}
        </div>
        ${secondaryText
          ? `<div class="archive-gift-voucher__date">${escapeHtml(secondaryText)}</div>`
          : ""}
        ${action.label && action.url
          ? card.isFallbackPromotion
            ? `<a class="archive-gift-voucher__action archive-gift-voucher__action--dark" href="${escapeHtml(action.url)}">${escapeHtml(action.label)} <span aria-hidden="true">&rarr;</span></a>
              <a class="archive-gift-voucher__learn-more" href="#" data-collector-milestone-learn-more>Learn more <span aria-hidden="true">&rarr;</span></a>`
            : `<a class="archive-gift-voucher__action archive-gift-voucher__action--dark" href="${escapeHtml(action.url)}">${escapeHtml(action.label)} <span aria-hidden="true">&rarr;</span></a>`
          : ""}
        ${renderGiftArt(card)}
      </article>
    `;
  }

  function getGiftPromotionCards(giftJourney) {
    const candidates = [
      giftJourney.promotionCard,
      giftJourney.promotion,
      giftJourney.marketingCard,
      giftJourney.currentPromotion
    ];

    if (Array.isArray(giftJourney.promotions)) {
      candidates.push(...giftJourney.promotions);
    }

    return candidates
      .filter(Boolean)
      .map(card => ({
        ...card,
        type: card.type || "Promotion",
        state: card.state || "Promotion"
      }));
  }

  function createFallbackPromotionCard() {
    return {
      key: "fallback-founding-member-promotion",
      title: "Founding Member Benefits",
      type: "Promotion",
      state: "Promotion",
      badge: "Limited Time",
      cashbackPercentage: 2,
      rewardLabel: "Milestone Rewards",
      description: "Join Archive Rewards before 31 Dec 2026 to become a Founding Member and permanently lock in double Milestone Benefits (2% instead of the standard 1%), in addition to the 1% Purchase Rewards earned on every eligible purchase.",
      descriptionHtml: `Join Archive Rewards before <strong class="archive-gift-voucher__emphasis archive-gift-voucher__emphasis--dark">31 Dec 2026</strong> to become a <strong class="archive-gift-voucher__emphasis archive-gift-voucher__emphasis--gold">Founding Member</strong> and permanently lock in double Milestone Benefits (<strong class="archive-gift-voucher__emphasis archive-gift-voucher__emphasis--gold">2%</strong> instead of the standard 1%), in addition to the 1% Purchase Rewards earned on every eligible purchase.`,
      ctaText: "Shop Now",
      ctaUrl: "/collections/all",
      isFallbackPromotion: true
    };
  }

  function renderPlaceholderGiftCard(card) {
    return `
      <article class="archive-gift-voucher archive-gift-voucher--empty">
        ${giftIconSvg()}
        <h3>${escapeHtml(card.title || "No gift vouchers yet")}</h3>
        <p>${escapeHtml(card.secondaryText || "When you receive a gift voucher, it will appear here.")}</p>
      </article>
    `;
  }

  function renderGiftJourney(giftJourney) {
    if (!summaryElements.giftGrid || !giftJourney?.cards) {
      return;
    }

    const promotionCards = getGiftPromotionCards(giftJourney);
    const hasConfiguredPromotion = promotionCards.length > 0 ||
      giftJourney.cards.some(card => getGiftCardType(card) === "promotion" || getGiftState(card) === "promotion");
    const effectivePromotionCards = hasConfiguredPromotion
      ? promotionCards
      : [createFallbackPromotionCard()];
    const baseCards = giftJourney.cards.filter(card => getGiftState(card) !== "placeholder");
    const cards = [
      ...baseCards,
      ...effectivePromotionCards.filter(promotionCard =>
        !baseCards.some(card =>
          getGiftCardType(card) === "promotion" &&
          (card.id || card.key || card.title) === (promotionCard.id || promotionCard.key || promotionCard.title)
        )
      )
    ];
    const renderedVoucherCodes = new Set(
      cards
        .map(card => card?.voucher?.voucherCode)
        .filter(Boolean)
    );
    const activeVouchers = Array.isArray(giftJourney.activeVouchers)
      ? giftJourney.activeVouchers
      : [];
    const extraActiveVouchers = activeVouchers.filter(voucher =>
      voucher?.voucherCode &&
      !renderedVoucherCodes.has(voucher.voucherCode)
    );
    const hasActiveMilestoneVoucher = extraActiveVouchers.some(voucher =>
      getGiftVoucherType(voucher) === 5
    );
    const outputCards = [];

    cards.forEach((card, index) => {
      const state = getGiftState(card);

      if (state === "activeVoucher") {
        outputCards.push(renderActiveGiftCard(card));
      } else if (state === "voucherGenerated") {
        outputCards.push(renderGeneratedGiftCard(card));
      } else if (state === "birthdayMissing") {
        outputCards.push(renderBirthdayMissingCard(card));
      } else if (state === "upcoming") {
        outputCards.push(renderUpcomingGiftCard(card));
      } else if (state === "readyToGenerate" || state === "claimWindow") {
        outputCards.push(renderGiftActionCard(card));
      } else if (state === "opportunityMissed") {
        outputCards.push(renderGiftMissedCard(card));
      } else if (state === "comingSoon") {
        if (Number.isFinite(Number(card.daysUntil))) {
          outputCards.push(renderUpcomingGiftCard(card));
        } else if (!hasActiveMilestoneVoucher) {
          outputCards.push(renderComingSoonGiftCard(card));
        }
      } else if (state === "promotion") {
        outputCards.push(renderPromotionGiftCard(card));
      } else {
        outputCards.push(renderPlaceholderGiftCard(card));
      }

      if (index === 1 && extraActiveVouchers.length > 0) {
        extraActiveVouchers.forEach(voucher => {
          outputCards.push(renderActiveGiftCard({
            title: getGiftVoucherTitle(voucher),
            voucher
          }));
        });
      }
    });

    const giftGridMarkup = outputCards.join("");
    const wasLoading = summaryElements.giftGrid.classList.contains("archive-gift-vouchers__grid--loading");

    if (wasLoading) {
      summaryElements.giftGrid.classList.add("archive-gift-vouchers__grid--replacing");

      window.setTimeout(() => {
        summaryElements.giftGrid.innerHTML = giftGridMarkup;
        summaryElements.giftGrid.classList.remove("archive-gift-vouchers__grid--loading");
        summaryElements.giftGrid.classList.remove("archive-gift-vouchers__grid--replacing");
        summaryElements.giftGrid.classList.add("archive-gift-vouchers__grid--loaded");
        giftCarouselPage = 1;
        updateGiftCarousel();
      }, 180);

      return;
    }

    summaryElements.giftGrid.innerHTML = giftGridMarkup;
    summaryElements.giftGrid.classList.add("archive-gift-vouchers__grid--loaded");
    giftCarouselPage = 1;
    updateGiftCarousel();
  }

  function getMilestoneStatusLabel(status) {
    return {
      reached: "Reached",
      inProgress: "In progress",
      upcoming: "Upcoming",
      locked: "Locked"
    }[status] || "Upcoming";
  }

  function renderMilestoneRewards(milestoneRewards) {
    if (!summaryElements.milestoneSection || !summaryElements.milestoneSteps) {
      return;
    }

    if (!milestoneRewards || !Array.isArray(milestoneRewards.milestones)) {
      summaryElements.milestoneSection.classList.add("archive-milestone-rewards--error");

      if (summaryElements.milestoneRemaining) {
        summaryElements.milestoneRemaining.textContent = "Milestone progress is temporarily unavailable.";
      }

      return;
    }

    const spend = Number(milestoneRewards.eligibleLifetimeSpendCents) || 0;
    const target = Number(milestoneRewards.nextMilestoneSpendCents) || 0;
    const remaining = Number(milestoneRewards.remainingSpendCents) || 0;
    const nextVoucher = Number(milestoneRewards.nextVoucherAmountCents) || 0;
    const progress = Math.max(0, Math.min(100, Number(milestoneRewards.progressPercentage) || 0));

    markSectionLoaded(
      summaryElements.milestoneSection,
      "archive-milestone-rewards--loading",
      "archive-milestone-rewards--loaded"
    );

    if (summaryElements.milestoneCurrent) {
      summaryElements.milestoneCurrent.textContent = formatWholeCurrency(spend);
    }

    if (summaryElements.milestoneTarget) {
      summaryElements.milestoneTarget.textContent = formatWholeCurrency(target);
    }

    if (summaryElements.milestoneProgressBar) {
      summaryElements.milestoneProgressBar.style.width = `${progress}%`;
    }

    if (summaryElements.milestoneProgressPercent) {
      summaryElements.milestoneProgressPercent.textContent = `${progress}%`;
    }

    if (summaryElements.milestoneSubcopy) {
      summaryElements.milestoneSubcopy.textContent = milestoneRewards.allMilestonesReached
        ? "Every current milestone has been reached."
        : "Spent towards your next milestone";
    }

    if (summaryElements.milestoneRemaining) {
      summaryElements.milestoneRemaining.textContent = milestoneRewards.allMilestonesReached
        ? milestoneRewards.completionMessage || "All current milestones reached. More collector milestones will be announced in the future."
        : `Only ${formatWholeCurrency(remaining)} more until your next ${formatWholeCurrency(nextVoucher)} Milestone Gift Voucher.`;
    }

    summaryElements.milestoneSteps.innerHTML = milestoneRewards.milestones
      .map(milestone => {
        const status = milestone.status || "upcoming";
        const rewardAmount = Number(milestone.voucherAmountCents || milestone.totalRewardAmountCents) || 0;

        return `
          <div class="archive-milestone-rewards__step archive-milestone-rewards__step--${escapeHtml(status.replace(/[A-Z]/g, match => `-${match.toLowerCase()}`))}">
            <span></span>
            <p>
              <strong>${escapeHtml(formatWholeCurrency(milestone.spendThresholdCents))} spent</strong>
              ${escapeHtml(formatWholeCurrency(rewardAmount))} Milestone Gift Voucher
            </p>
            <em>${escapeHtml(getMilestoneStatusLabel(status))}</em>
          </div>
        `;
      })
      .join("");
  }

  function getGiftCarouselPageSize() {
    if (window.matchMedia("(min-width: 990px)").matches) {
      return 4;
    }

    if (window.matchMedia("(min-width: 750px)").matches) {
      return 2;
    }

    return 1;
  }

  function updateGiftCarousel() {
    if (!summaryElements.giftGrid) {
      return;
    }

    const cards = Array.from(summaryElements.giftGrid.querySelectorAll(".archive-gift-voucher"));
    const pageSize = getGiftCarouselPageSize();
    const totalPages = Math.max(1, Math.ceil(cards.length / pageSize));

    giftCarouselPage = Math.min(Math.max(giftCarouselPage, 1), totalPages);

    const start = (giftCarouselPage - 1) * pageSize;
    const end = start + pageSize;

    cards.forEach((card, index) => {
      card.hidden = index < start || index >= end;
    });

    const shouldShowNavigation = cards.length > pageSize;

    [summaryElements.giftPreviousButton, summaryElements.giftNextButton].forEach(button => {
      if (!button) {
        return;
      }

      button.hidden = !shouldShowNavigation;
    });

    if (summaryElements.giftPreviousButton) {
      summaryElements.giftPreviousButton.disabled = giftCarouselPage === 1;
    }

    if (summaryElements.giftNextButton) {
      summaryElements.giftNextButton.disabled = giftCarouselPage === totalPages;
    }
  }

  function showGiftCarouselPage(page) {
    giftCarouselPage = page;
    updateGiftCarousel();
  }

  function setInfoText(element, message, allowHtml = false) {
    if (!element) {
      return;
    }

    if (allowHtml) {
      element.innerHTML = message;
      return;
    }

    element.textContent = message;
  }

  function getVoucherLabel(threshold) {
    return `$${threshold / 100}`;
  }

  function getNextRewardProgress(profile) {
    const redemption = profile?.redemption || {};
    const availableCents = centsToPoints(profile?.availableRewardCents);
    const options = Array.isArray(redemption.voucherOptions)
      ? redemption.voucherOptions
          .map(option => Number(option.amountCents) || 0)
          .filter(amount => amount > 0)
          .sort((a, b) => a - b)
      : [];
    const highestOption = options[options.length - 1] || Number(redemption.maximumRedeemableAmountCents) || availableCents;
    const nextAmount = Number(redemption.nextVoucherAmountCents) || options.find(amount => availableCents < amount) || 0;

    if (!nextAmount) {
      return {
        isComplete: true,
        threshold: highestOption,
        current: availableCents,
        target: highestOption,
        remaining: 0,
        percent: 100
      };
    }

    const target = nextAmount;
    const percent = Math.max(0, Math.min(100, (availableCents / target) * 100));

    return {
      isComplete: false,
      threshold: target,
      current: availableCents,
      target,
      remaining: Math.max(0, Number(redemption.rewardBalanceToNextVoucherCents) || target - availableCents),
      percent
    };
  }

  function readBooleanField(source, camelName, pascalName) {
    return Boolean(source?.[camelName] ?? source?.[pascalName]);
  }

  function updateProfileCompletionPanel(profile) {
    // Uses the API result: a completion recorded at or above the $100 earning threshold added no points.
    if (summaryElements.profileCompletionConfirmationText) {
      summaryElements.profileCompletionConfirmationText.textContent =
        readBooleanField(profile, "profileCompletionRewardBlockedByEarningThreshold", "ProfileCompletionRewardBlockedByEarningThreshold")
          ? "No Reward Points were added because your Rewards balance had reached the $100 earning threshold."
          : "500 Reward Points have been added to your account.";
    }

    if (!summaryElements.profileCompletionPanel) {
      return;
    }

    const shouldShow =
      readBooleanField(profile, "showProfileCompletionRewardPanel", "ShowProfileCompletionRewardPanel");

    summaryElements.profileCompletionPanel.hidden = !shouldShow;
  }

  function showProfileCompletionConfirmation() {
    const element = summaryElements.profileCompletionConfirmation;

    if (!element || !shouldShowProfileCompletionConfirmation) {
      return;
    }

    shouldShowProfileCompletionConfirmation = false;
    element.hidden = false;
    element.classList.remove("is-hiding");

    window.requestAnimationFrame(() => {
      element.classList.add("is-visible");
    });
  }

  function updateRewardProgress(profile) {
    if (!summaryElements.progress) {
      return;
    }

    if (!profile) {
      summaryElements.progress.hidden = true;
      updateProfileCompletionPanel(null);
      return;
    }

    const progress = getNextRewardProgress(profile);

    summaryElements.progress.hidden = false;
    markSectionLoaded(
      summaryElements.progress,
      "archive-rewards-progress--loading",
      "archive-rewards-progress--loaded"
    );
    updateProfileCompletionPanel(profile);

    if (summaryElements.progressMeter) {
      summaryElements.progressMeter.hidden = progress.isComplete;
    }

    if (summaryElements.progressComplete) {
      summaryElements.progressComplete.hidden = !progress.isComplete;
    }

    if (progress.isComplete) {
      if (summaryElements.progressTitle) {
        summaryElements.progressTitle.textContent = "Your highest reward voucher is ready";
      }

      if (summaryElements.progressCopy) {
        summaryElements.progressCopy.textContent = "Generate your $100 Reward Voucher below.";
      }

      if (summaryElements.progressWaysTitle) {
        summaryElements.progressWaysTitle.textContent = "More ways to keep earning";
      }

      return;
    }

    if (summaryElements.progressTitle) {
      summaryElements.progressTitle.innerHTML = "Your progress<br>to your next reward";
    }

    if (summaryElements.progressCopy) {
      summaryElements.progressCopy.textContent = "You're doing great. Keep going to unlock more rewards.";
    }

    if (summaryElements.progressCurrent) {
      summaryElements.progressCurrent.textContent = formatPoints(progress.current);
    }

    if (summaryElements.progressTarget) {
      summaryElements.progressTarget.textContent = formatPoints(progress.target);
    }

    if (summaryElements.progressBar) {
      const formattedPercent = Number.isInteger(progress.percent)
        ? `${progress.percent}%`
        : `${progress.percent.toFixed(1)}%`;

      summaryElements.progressBar.style.width = `${progress.percent}%`;
      summaryElements.progressBar.textContent = formattedPercent;
    }

    if (summaryElements.progressRemaining) {
      const targetLabel = getVoucherLabel(progress.threshold);
      const firstText = progress.threshold === 1000 ? "first " : "";

      summaryElements.progressRemaining.textContent = `${formatPoints(progress.remaining)} points until your ${firstText}${targetLabel} Reward Voucher`;
    }

    showProfileCompletionConfirmation();

    if (summaryElements.progressWaysTitle) {
      summaryElements.progressWaysTitle.textContent = `Need another ${formatPoints(progress.remaining)} points?`;
    }
  }

  function updateBestOptionBadge(profile) {
    const hasActiveVoucher = Boolean(profile?.activeVoucherCode);
    const availableCents = centsToPoints(profile?.availableRewardCents);
    let bestButton = null;

    summaryElements.generateButtons.forEach(button => {
      const amountCents = Number(button.dataset.rewardsVoucherAmountCents);
      const card = button.closest("[data-rewards-voucher-card]");
      const badge = card ? card.querySelector("[data-rewards-best-badge]") : null;
      const canGenerate = Boolean(profile) && !hasActiveVoucher && availableCents >= amountCents;

      if (badge) {
        badge.hidden = true;
      }

      if (card) {
        card.classList.remove("archive-voucher-card--best");
      }

      if (canGenerate && (!bestButton || amountCents > Number(bestButton.dataset.rewardsVoucherAmountCents))) {
        bestButton = button;
      }
    });

    if (!bestButton) {
      return;
    }

    const card = bestButton.closest("[data-rewards-voucher-card]");
    const badge = card ? card.querySelector("[data-rewards-best-badge]") : null;

    if (card) {
      card.classList.add("archive-voucher-card--best");
    }

    if (badge) {
      badge.hidden = false;
    }
  }

  function updateNewsletterSection(status) {
    if (!summaryElements.newsletter) {
      return;
    }

    summaryElements.newsletter.hidden = false;

    if (!summaryElements.newsletterCheckbox) {
      return;
    }

    const isSubscribed = Boolean(status?.isSubscribed);

    updateNewsletterRewardText(status);
    markSectionLoaded(
      summaryElements.newsletter,
      "archive-rewards-newsletter--loading",
      "archive-rewards-newsletter--loaded"
    );
    summaryElements.newsletter.classList.toggle("archive-rewards-newsletter--subscribed", isSubscribed);
    summaryElements.newsletterCheckbox.checked = isSubscribed;
    summaryElements.newsletterCheckbox.disabled = !customerConfig.isAuthenticated || isSubscribingNewsletter;

    if (summaryElements.newsletterNote) {
      const rewardLabel = getNewsletterRewardLabel(status);

      summaryElements.newsletterNote.textContent = isSubscribed
        ? isNewsletterRewardThresholdBlocked(status)
          ? "No Reward Points were added for this subscription because your Rewards balance had reached the $100 earning threshold, so unsubscribing will not remove any points."
          : `Reward Points are awarded while your newsletter subscription remains active. Unsubscribing will remove the ${rewardLabel} from your account.`
        : `Subscribe to receive ${rewardLabel} when eligible.`;
    }
  }

  function initializeGuestPreview() {
    if (summaryElements.progress) {
      summaryElements.progress.hidden = false;
      summaryElements.progress.classList.add("archive-rewards-progress--guest");
    }

    if (summaryElements.progressTitle) {
      summaryElements.progressTitle.innerHTML = "Your progress<br>to your first reward";
    }

    if (summaryElements.progressCopy) {
      summaryElements.progressCopy.textContent =
        "Sign in to start earning Reward Points and track your progress towards your first reward voucher.";
    }

    if (summaryElements.progressMeter) {
      summaryElements.progressMeter.hidden = false;
    }

    if (summaryElements.progressComplete) {
      summaryElements.progressComplete.hidden = true;
    }

    if (summaryElements.progressCurrent) {
      summaryElements.progressCurrent.textContent = "0";
    }

    if (summaryElements.progressTarget) {
      summaryElements.progressTarget.textContent = "1,000";
    }

    if (summaryElements.progressBar) {
      summaryElements.progressBar.style.width = "0%";
      summaryElements.progressBar.textContent = "0%";
    }

    if (summaryElements.progressRemaining) {
      summaryElements.progressRemaining.textContent = "Sign in to unlock your first $10 Reward Voucher.";
    }

    if (summaryElements.progressWaysTitle) {
      summaryElements.progressWaysTitle.textContent = "Member earning actions";
    }

    updateProfileCompletionPanel(null);

    summaryElements.progress?.querySelectorAll("button, input, a:not([data-archive-rewards-modal-open])").forEach(control => {
      control.setAttribute("aria-disabled", "true");
      control.tabIndex = -1;
    });

    if (summaryElements.newsletter) {
      summaryElements.newsletter.hidden = false;
      summaryElements.newsletter.classList.remove("archive-rewards-newsletter--subscribed");
    }

    if (summaryElements.newsletterCheckbox) {
      summaryElements.newsletterCheckbox.checked = false;
      summaryElements.newsletterCheckbox.disabled = true;
    }

    if (summaryElements.newsletterNote) {
      summaryElements.newsletterNote.textContent =
        "Sign in and subscribe to receive 500 Reward Points when eligible.";
    }

    updateGiftCarousel();
  }

  function setButtonLoading(button, isLoading, loadingText) {
    if (!button) {
      return;
    }

    if (!button.dataset.originalHtml) {
      button.dataset.originalHtml = button.innerHTML;
    }

    button.disabled = isLoading;
    button.setAttribute("aria-busy", String(isLoading));
    button.classList.toggle("is-loading", isLoading);
    button.innerHTML = isLoading
      ? `<span class="archive-rewards-button-spinner" aria-hidden="true"></span> ${loadingText}`
      : button.dataset.originalHtml;
  }

  function setGenerateButtonAvailability(button, isEnabled) {
    if (!button || button.classList.contains("is-loading")) {
      return;
    }

    button.disabled = !isEnabled;
    button.setAttribute("aria-disabled", String(!isEnabled));
  }

  function updateVoucherGenerationState(profile) {
    const hasActiveVoucher = Boolean(profile?.activeVoucherCode);
    const availableCents = centsToPoints(profile?.availableRewardCents);
    const redemption = profile?.redemption || {};
    const minimumAmountCents = Number(redemption.minimumAmountCents) || 0;
    const hasMinimumBalance = minimumAmountCents > 0 && availableCents >= minimumAmountCents;

    if (hasActiveVoucher) {
      setInfoText(
        summaryElements.topInfo,
        "You have an active reward voucher. You can convert it back to points or redeem it at checkout."
      );
      setInfoText(
        summaryElements.bottomInfo,
        "You have an active reward voucher. Convert it back to points or redeem it before generating a new one."
      );
    } else if (hasMinimumBalance) {
      setInfoText(
        summaryElements.topInfo,
        "Your Reward Points are ready. Select a reward voucher below to convert your points, then redeem your voucher towards your next exceptional whisky."
      );
      setInfoText(
        summaryElements.bottomInfo,
        "Choose a reward voucher amount to redeem your points."
      );
    } else if (profile) {
      const minimumPoints = formatPoints(minimumAmountCents || redemption.minimumVoucherAmountCents || 1000);

      setInfoText(
        summaryElements.topInfo,
        "Keep earning Reward Points to unlock your first reward voucher."
      );
      setInfoText(
        summaryElements.bottomInfo,
        `You need at least ${minimumPoints} Reward Points to generate your first reward voucher. Earn more points through eligible purchases, verified reviews, newsletter subscription, or by completing your <a href="/pages/archive-persona">Archive Profile</a>.`,
        true
      );
    }

    summaryElements.generateButtons.forEach(button => {
      const amountCents = Number(button.dataset.rewardsVoucherAmountCents);
      const isEnabled = Boolean(profile) &&
        Boolean(redemption.canRedeem) &&
        !hasActiveVoucher &&
        amountCents <= Number(redemption.maximumRedeemableAmountCents || availableCents);

      setGenerateButtonAvailability(button, isEnabled);
    });

    updateRewardProgress(profile);
    updateBestOptionBadge(profile);
  }

  function createConfirmDialog() {
    const element = document.createElement("div");

    element.className = "archive-rewards-confirm";
    element.setAttribute("aria-hidden", "true");
    element.innerHTML = `
      <div class="archive-rewards-confirm__backdrop" data-rewards-action-cancel></div>
      <div class="archive-rewards-confirm__dialog" role="dialog" aria-modal="true" aria-labelledby="archiveRewardsConfirmTitle" aria-describedby="archiveRewardsConfirmMessage">
        <button type="button" class="archive-rewards-confirm__close" data-rewards-action-cancel aria-label="Close">&times;</button>
        <h2 id="archiveRewardsConfirmTitle" data-rewards-confirm-title></h2>
        <p id="archiveRewardsConfirmMessage" data-rewards-confirm-message></p>
        <div class="archive-rewards-confirm__actions">
          <button type="button" class="archive-rewards-confirm__button archive-rewards-confirm__button--secondary" data-rewards-action-cancel>Cancel</button>
          <button type="button" class="archive-rewards-confirm__button archive-rewards-confirm__button--primary" data-rewards-action-confirm></button>
        </div>
      </div>
    `;

    document.body.appendChild(element);

    element.querySelectorAll("[data-rewards-action-cancel]").forEach(control => {
      control.addEventListener("click", () => closeConfirmDialog(false));
    });

    const confirmButton = element.querySelector("[data-rewards-action-confirm]");

    if (confirmButton) {
      confirmButton.addEventListener("click", () => closeConfirmDialog(true));
    }

    return element;
  }

  function closeConfirmDialog(result) {
    if (!confirmDialog) {
      return;
    }

    confirmDialog.classList.remove("is-open");
    confirmDialog.setAttribute("aria-hidden", "true");
    document.body.classList.remove("archive-rewards-modal-open");

    if (lastFocusedElement) {
      lastFocusedElement.focus();
    }

    if (confirmResolve) {
      confirmResolve(result);
      confirmResolve = null;
    }
  }

  function requestActionConfirmation({ title, message, confirmLabel }) {
    if (!confirmDialog) {
      confirmDialog = createConfirmDialog();
    }

    const titleElement = confirmDialog.querySelector("[data-rewards-confirm-title]");
    const messageElement = confirmDialog.querySelector("[data-rewards-confirm-message]");
    const confirmButton = confirmDialog.querySelector("[data-rewards-action-confirm]");

    if (titleElement) {
      titleElement.textContent = title;
    }

    if (messageElement) {
      messageElement.innerHTML = message;
    }

    if (confirmButton) {
      confirmButton.textContent = confirmLabel;
    }

    lastFocusedElement = document.activeElement;
    confirmDialog.classList.add("is-open");
    confirmDialog.setAttribute("aria-hidden", "false");
    document.body.classList.add("archive-rewards-modal-open");

    if (confirmButton) {
      confirmButton.focus();
    }

    return new Promise(resolve => {
      confirmResolve = resolve;
    });
  }

  function createBirthdayDialog() {
    const element = document.createElement("div");

    element.className = "archive-rewards-birthday";
    element.setAttribute("aria-hidden", "true");
    element.innerHTML = `
      <div class="archive-rewards-birthday__backdrop" data-rewards-birthday-close></div>
      <form class="archive-rewards-birthday__dialog" role="dialog" aria-modal="true" aria-labelledby="archiveRewardsBirthdayTitle" novalidate>
        <button type="button" class="archive-rewards-birthday__close" data-rewards-birthday-close aria-label="Close">&times;</button>
        <h2 id="archiveRewardsBirthdayTitle">Add your birthday</h2>
        <p>Save your birthday to unlock your complimentary birthday gift voucher when eligible.</p>
        <label>
          Birthday
          <input type="date" name="birthday" autocomplete="bday" required aria-describedby="archiveRewardsBirthdayHint archiveRewardsBirthdayError">
        </label>
        <p id="archiveRewardsBirthdayHint" class="archive-rewards-birthday__hint">You must be 18 or over. Once saved, your birthday can&rsquo;t be changed.</p>
        <p id="archiveRewardsBirthdayError" class="archive-rewards-birthday__error" role="alert" hidden></p>
        <div class="archive-rewards-birthday__actions">
          <button type="button" class="archive-rewards-birthday__button archive-rewards-birthday__button--secondary" data-rewards-birthday-close>Cancel</button>
          <button type="submit" class="archive-rewards-birthday__button archive-rewards-birthday__button--primary">Save Birthday</button>
        </div>
      </form>
    `;

    document.body.appendChild(element);

    element.querySelectorAll("[data-rewards-birthday-close]").forEach(control => {
      control.addEventListener("click", () => closeBirthdayDialog());
    });

    const form = element.querySelector("form");

    if (form) {
      form.addEventListener("submit", handleBirthdaySubmit);
    }

    const input = element.querySelector("input[name='birthday']");

    if (input) {
      input.addEventListener("input", () => setBirthdayError(""));
    }

    return element;
  }

  // The dialog's inline message: the browser's check or the server's refusal, read out at once.
  function setBirthdayError(message) {
    if (!birthdayDialog) {
      return;
    }

    const error = birthdayDialog.querySelector(".archive-rewards-birthday__error");
    const input = birthdayDialog.querySelector("input[name='birthday']");

    if (error) {
      error.textContent = message || "";
      error.hidden = !message;
    }

    if (input) {
      if (message) {
        input.setAttribute("aria-invalid", "true");
      } else {
        input.removeAttribute("aria-invalid");
      }
    }
  }

  function createGiftVouchersInfoDialog() {
    const element = document.createElement("div");

    element.className = "archive-rewards-gift-info";
    element.setAttribute("aria-hidden", "true");
    element.innerHTML = `
      <div class="archive-rewards-gift-info__backdrop" data-gift-vouchers-modal-close></div>
      <div class="archive-rewards-gift-info__dialog" role="dialog" aria-modal="true" aria-labelledby="archiveRewardsGiftInfoTitle">
        <button type="button" class="archive-rewards-gift-info__close" data-gift-vouchers-modal-close aria-label="Close">&times;</button>
        <p class="archive-rewards-gift-info__eyebrow">Gift Vouchers</p>
        <h2 id="archiveRewardsGiftInfoTitle">How Gift Vouchers Work</h2>
        <div class="archive-rewards-gift-info__grid">
          <article>
            <span>01</span>
            <strong>Complimentary Gifts</strong>
            <p>Birthday, anniversary and milestone vouchers are gifts from The Whisky Archive.</p>
          </article>
          <article>
            <span>02</span>
            <strong>Promotional Vouchers</strong>
            <p>Limited-time gift rewards may appear during special campaigns or member events.</p>
          </article>
          <article>
            <span>03</span>
            <strong>Fixed Expiry</strong>
            <p>Gift vouchers keep their own expiry dates and cannot be converted back to Reward Points.</p>
          </article>
          <article>
            <span>04</span>
            <strong>At Checkout</strong>
            <p>Use one eligible gift voucher per order alongside the rules shown at checkout.</p>
          </article>
        </div>
        <button type="button" class="archive-rewards-gift-info__button" data-gift-vouchers-modal-close>Close</button>
      </div>
    `;

    document.body.appendChild(element);

    element.querySelectorAll("[data-gift-vouchers-modal-close]").forEach(control => {
      control.addEventListener("click", closeGiftVouchersInfoDialog);
    });

    return element;
  }

  function openGiftVouchersInfoDialog() {
    if (!giftVouchersInfoDialog) {
      giftVouchersInfoDialog = createGiftVouchersInfoDialog();
    }

    const closeButton = giftVouchersInfoDialog.querySelector(".archive-rewards-gift-info__close");

    lastFocusedElement = document.activeElement;
    giftVouchersInfoDialog.classList.add("is-open");
    giftVouchersInfoDialog.setAttribute("aria-hidden", "false");
    document.body.classList.add("archive-rewards-modal-open");

    if (closeButton) {
      closeButton.focus();
    }
  }

  function closeGiftVouchersInfoDialog() {
    if (!giftVouchersInfoDialog) {
      return;
    }

    giftVouchersInfoDialog.classList.remove("is-open");
    giftVouchersInfoDialog.setAttribute("aria-hidden", "true");
    document.body.classList.remove("archive-rewards-modal-open");

    if (lastFocusedElement) {
      lastFocusedElement.focus();
    }
  }

  function openMilestoneRewardsInfoDialog() {
    milestoneRewardsInfoDialog = milestoneRewardsInfoDialog || document.querySelector("[data-milestone-rewards-modal]");

    if (!milestoneRewardsInfoDialog) {
      return;
    }

    const closeButton = milestoneRewardsInfoDialog.querySelector(".archive-rewards-gift-info__close");

    lastFocusedElement = document.activeElement;
    milestoneRewardsInfoDialog.classList.add("is-open");
    milestoneRewardsInfoDialog.setAttribute("aria-hidden", "false");
    document.body.classList.add("archive-rewards-modal-open");

    if (closeButton) {
      closeButton.focus();
    }
  }

  function closeMilestoneRewardsInfoDialog() {
    if (!milestoneRewardsInfoDialog) {
      return;
    }

    milestoneRewardsInfoDialog.classList.remove("is-open");
    milestoneRewardsInfoDialog.setAttribute("aria-hidden", "true");
    document.body.classList.remove("archive-rewards-modal-open");

    if (lastFocusedElement) {
      lastFocusedElement.focus();
    }
  }

  function openBirthdayDialog(fallbackUrl) {
    if (!profileLoadEndpoint || !profileSaveEndpoint || !customerId) {
      window.location.href = fallbackUrl || "/pages/archive-persona";
      return;
    }

    if (!birthdayDialog) {
      birthdayDialog = createBirthdayDialog();
    }

    const input = birthdayDialog.querySelector("input[name='birthday']");

    if (input) {
      input.value = "";

      // 18 or over on today's Melbourne date (assets/archive-birthday.js). A hint only: every
      // submission is checked again, here and by the server.
      if (window.ArchiveBirthday) {
        window.ArchiveBirthday.constrainInput(input);
      } else {
        input.max = new Date().toISOString().slice(0, 10);
      }
    }

    setBirthdayError("");
    lastFocusedElement = document.activeElement;
    birthdayDialog.classList.add("is-open");
    birthdayDialog.setAttribute("aria-hidden", "false");
    document.body.classList.add("archive-rewards-modal-open");

    if (input) {
      input.focus();
    }
  }

  function closeBirthdayDialog() {
    if (!birthdayDialog || isSavingBirthday) {
      return;
    }

    birthdayDialog.classList.remove("is-open");
    birthdayDialog.setAttribute("aria-hidden", "true");
    document.body.classList.remove("archive-rewards-modal-open");

    if (lastFocusedElement) {
      lastFocusedElement.focus();
    }
  }

  async function loadArchiveProfile() {
    const response = await fetch(
      `${profileLoadEndpoint}?customerId=${encodeURIComponent(customerId)}`,
      {
        method: "GET",
        credentials: "same-origin",
        headers: {
          Accept: "application/json"
        }
      });

    if (!response.ok) {
      throw new Error("Archive Profile load failed.");
    }

    const result = await response.json();

    return result.profile && typeof result.profile === "object"
      ? result.profile
      : {};
  }

  // Rejects with the shared BirthdayRequestError (kind: validation | conflict | network | server,
  // plus the server's reasonCode and message on a 400) when assets/archive-birthday.js is loaded.
  async function saveArchiveProfile(birthday) {
    if (window.ArchiveBirthday) {
      return window.ArchiveBirthday.save({ endpoint: profileSaveEndpoint, customerId, birthday });
    }

    const response = await fetch(profileSaveEndpoint, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        customerId,
        operation: "Birthday",
        profile: { birthday }
      })
    });

    if (!response.ok) {
      const message = await response.text();

      throw new Error(message || "Archive Profile save failed.");
    }
  }

  async function handleBirthdaySubmit(event) {
    event.preventDefault();

    if (isSavingBirthday) {
      return;
    }

    const form = event.currentTarget;
    const input = form.querySelector("input[name='birthday']");
    const submitButton = form.querySelector("button[type='submit']");
    const rules = window.ArchiveBirthday;
    let birthday = input?.value;

    // The same rules as the server (required, a real date, 1900 or later, not in the future, 18 or
    // over today in Melbourne): nothing it would refuse is sent.
    if (rules) {
      const check = rules.validateSubmission(birthday);

      if (!check.ok) {
        setBirthdayError(check.message);
        input?.focus();
        return;
      }

      birthday = check.iso;
    } else if (!birthday) {
      return;
    }

    setBirthdayError("");
    isSavingBirthday = true;
    setButtonLoading(submitButton, true, "Saving");

    let saved = false;
    let failure = null;

    try {
      await loadArchiveProfile();
      await saveArchiveProfile(birthday);
      saved = true;
    } catch (error) {
      failure = error;
    } finally {
      setButtonLoading(submitButton, false, "Saving");
      isSavingBirthday = false;
    }

    if (!saved) {
      // A birthday that is already saved (BirthdayLocked): nothing to change here - close and show
      // the dashboard as it now stands.
      if (failure && failure.reasonCode === "BirthdayLocked") {
        closeBirthdayDialog();
        await loadRewardProfile();
        showToast({ title: "Birthday already saved", message: failure.message, tone: "error" });
        return;
      }

      setBirthdayError(
        failure && failure.kind
          ? failure.message
          : "We couldn’t save your birthday. Please check your connection and try again.");
      input?.focus();
      return;
    }

    closeBirthdayDialog();

    const refreshed = await loadRewardProfile();

    showToast(refreshed
      ? { title: "Birthday saved", message: "Your Gift Vouchers have been refreshed." }
      : { title: "Birthday saved", message: "Refresh the page to see your Gift Vouchers." });
  }

  async function convertVoucherToPoints() {
    const response = await fetch(convertEndpoint, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json"
      }
    });

    if (!response.ok) {
      const message = await response.text();

      throw new Error(message || "Reward voucher conversion failed.");
    }
  }

  async function handleConvertClick() {
    if (isConvertingVoucher) {
      return;
    }

    const confirmed = await requestActionConfirmation({
      title: "Convert Reward Voucher?",
      message: "Convert this Reward Voucher back into Reward Points?<span>Your voucher will be cancelled and its full value will be returned to your available Reward Points.</span><span>This action cannot be undone.</span>",
      confirmLabel: "Convert to Points"
    });

    if (!confirmed) {
      return;
    }

    isConvertingVoucher = true;
    setButtonLoading(summaryElements.convertButton, true, "Converting");

    try {
      await convertVoucherToPoints();
      setButtonLoading(summaryElements.convertButton, false, "Converting");

      const refreshed = await loadRewardProfile();

      if (!refreshed) {
        throw new Error("Reward profile refresh failed.");
      }

      showToast({
        title: "Reward voucher converted",
        message: "Reward voucher converted back to points."
      });
    } catch (error) {
      setButtonLoading(summaryElements.convertButton, false, "Converting");
      showToast({
        title: "Unable to convert voucher",
        message: "Please try again or contact us if the issue continues.",
        tone: "error"
      });
    } finally {
      isConvertingVoucher = false;
    }
  }

  async function generateRewardVoucher(amountCents, options = {}) {
    const voucherType = Number(options.voucherType) || 1;
    const payload = {
      voucherType,
      amountCents,
      requestedBy: "Archive Rewards"
    };

    if (options.startsAtUtc) {
      payload.startsAtUtc = options.startsAtUtc;
    }

    const response = await fetch(generateEndpoint, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      const message = await response.text();

      throw new Error(message || "Reward voucher generation failed.");
    }
  }

  async function updateNewsletterReward(isSubscribed) {
    if (!newsletterEndpoint) {
      throw new Error("Newsletter subscription endpoint is not configured.");
    }

    const response = await fetch(newsletterEndpoint, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        isSubscribed
      })
    });

    if (!response.ok) {
      const message = await response.text();

      throw new Error(message || "Newsletter subscription update failed.");
    }

    return await response.json();
  }

  async function handleGenerateClick(event) {
    const button = event.currentTarget;
    const amountCents = Number(button.dataset.rewardsVoucherAmountCents);
    const voucherType = Number(button.dataset.rewardsVoucherType) || 1;
    const startsAtUtc = button.dataset.rewardsVoucherStartsAt || "";
    const isGiftVoucher = voucherType !== 1;

    if (isGeneratingVoucher || button.disabled || !Number.isFinite(amountCents)) {
      return;
    }

    const confirmed = await requestActionConfirmation({
      title: isGiftVoucher ? "Generate Gift Voucher?" : "Generate Reward Voucher?",
      message: isGiftVoucher
        ? `Generate your ${formatVoucherAmount(amountCents)} Gift Voucher?<span>Your voucher validity begins from the day it is generated.</span>`
        : `Generate a ${formatVoucherAmount(amountCents)} Reward Voucher using your Reward Points?<span>Your Reward Points will immediately be converted into a Reward Voucher which can be redeemed at checkout.</span>`,
      confirmLabel: "Generate Voucher"
    });

    if (!confirmed) {
      return;
    }

    isGeneratingVoucher = true;
    setButtonLoading(button, true, "Generating");

    try {
      await generateRewardVoucher(amountCents, {
        voucherType,
        startsAtUtc
      });
      setButtonLoading(button, false, "Generating");

      const refreshed = await loadRewardProfile();

      if (!refreshed) {
        throw new Error("Reward profile refresh failed.");
      }

      showToast({
        title: isGiftVoucher ? "Gift voucher generated" : "Reward voucher generated",
        message: isGiftVoucher
          ? "Your gift voucher is ready to use."
          : "Reward voucher generated successfully."
      });
    } catch (error) {
      setButtonLoading(button, false, "Generating");
      updateVoucherGenerationState(window.archiveRewardsCurrentProfile || null);
      showToast({
        title: "Unable to generate voucher",
        message: "Please try again or contact us if the issue continues.",
        tone: "error"
      });
    } finally {
      isGeneratingVoucher = false;
    }
  }

  async function handleNewsletterChange(event) {
    const checkbox = event.currentTarget;
    const wasSubscribed = Boolean(window.archiveRewardsNewsletterStatus?.isSubscribed);
    const wantsSubscription = checkbox.checked;
    const rewardLabel = getNewsletterRewardLabel(window.archiveRewardsNewsletterStatus);
    const wasThresholdBlocked = isNewsletterRewardThresholdBlocked(window.archiveRewardsNewsletterStatus);

    if (isSubscribingNewsletter || wantsSubscription === wasSubscribed) {
      return;
    }

    const confirmed = await requestActionConfirmation(
      wantsSubscription
        ? {
            title: "Subscribe to Newsletter?",
            message: `Receive exclusive updates about new arrivals, special releases and member offers.<span>You will receive ${rewardLabel} when eligible.</span>`,
            confirmLabel: "Subscribe"
          }
        : {
            title: "Unsubscribe from Newsletter?",
            message: wasThresholdBlocked
              ? "You may no longer receive exclusive updates about new arrivals, special releases and member offers."
              : `You may no longer receive exclusive updates about new arrivals, special releases and member offers.<span>Your ${rewardLabel} will be revoked. This may result in a negative available Reward Points balance, which must be earned back before generating another reward voucher.</span>`,
            confirmLabel: "Unsubscribe"
          });

    if (!confirmed) {
      checkbox.checked = wasSubscribed;
      return;
    }

    isSubscribingNewsletter = true;
    checkbox.disabled = true;

    try {
      const status = await updateNewsletterReward(
        wantsSubscription);

      window.archiveRewardsNewsletterStatus = status;

      const refreshed = await loadRewardProfile();

      if (!refreshed) {
        throw new Error("Reward profile refresh failed.");
      }

      updateNewsletterSection(status);

      const rewardBlocked = wantsSubscription && isNewsletterRewardThresholdBlocked(status);

      showToast({
        title: wantsSubscription
          ? rewardBlocked ? "Newsletter subscription confirmed" : "Newsletter reward added"
          : "Newsletter subscription removed",
        message: wantsSubscription
          ? rewardBlocked
            ? "No Reward Points were added because your Rewards balance has reached the $100 earning threshold."
            : `${rewardLabel} have been added to your balance.`
          : wasThresholdBlocked
            ? "Newsletter subscription removed."
            : `Newsletter subscription removed. ${rewardLabel} were revoked.`
      });
    } catch (error) {
      checkbox.checked = wasSubscribed;
      updateNewsletterSection(window.archiveRewardsNewsletterStatus || { isSubscribed: wasSubscribed });
      showToast({
        title: wantsSubscription ? "Unable to subscribe" : "Unable to unsubscribe",
        message: "Please try again or contact us if the issue continues.",
        tone: "error"
      });
    } finally {
      isSubscribingNewsletter = false;
      updateNewsletterSection(window.archiveRewardsNewsletterStatus || { isSubscribed: wasSubscribed });
    }
  }


  async function loadRewardProfile() {
    try {
      const response = await fetch(endpoint, {
        method: "GET",
        credentials: "same-origin",
        headers: {
          Accept: "application/json"
        }
      });

      if (!response.ok) {
        throw new Error("Reward profile request failed.");
      }

      const profile = await response.json();
      window.archiveRewardsCurrentProfile = profile;

      if (profile.archiveProfileCreated === true) {
        try {
          if (typeof fbq === "function") {
            fbq("track", "CompleteRegistration");
          }
        } catch (error) {
          console.warn("Unable to send Meta CompleteRegistration event.", error);
        }
      }

      setPoints(summaryElements.balancePoints, profile.availableRewardCents);
      setPoints(summaryElements.earnedPoints, profile.lifetimeEarnedCents);
      setPoints(summaryElements.redeemedPoints, profile.lifetimeRedeemedCents);

      if (summaryElements.balanceValue) {
        summaryElements.balanceValue.textContent = `${formatCurrencyFromCents(profile.availableRewardCents)} in value`;
      }

      if (summaryElements.earnedText) {
        summaryElements.earnedText.textContent = "Total rewards earned";
      }

      if (summaryElements.redeemedValue) {
        summaryElements.redeemedValue.textContent = `${formatCurrencyFromCents(profile.lifetimeRedeemedCents)} redeemed`;
      }

      showActiveVoucher(profile);
      renderVoucherOptions(profile);
      renderGiftJourney(profile.giftJourney);
      renderMilestoneRewards(profile.milestoneRewards);
      updateVoucherGenerationState(profile);
      window.archiveRewardsNewsletterStatus = profile.newsletter || { isSubscribed: false };
      updateNewsletterSection(window.archiveRewardsNewsletterStatus);
      return true;
    } catch (error) {
      window.archiveRewardsCurrentProfile = null;
      setSummaryError();
      return false;
    }
  }

  const guestIntentStorageKey = "twaArchiveRewardsGuestIntent.v1";

  async function applyStashedGuestIntent() {
    let intent;

    try {
      const raw = window.localStorage.getItem(guestIntentStorageKey);

      if (!raw) {
        return;
      }

      intent = JSON.parse(raw);
    } catch (error) {
      window.localStorage.removeItem(guestIntentStorageKey);
      return;
    }

    if (!intent || typeof intent !== "object") {
      window.localStorage.removeItem(guestIntentStorageKey);
      return;
    }

    // A birthday kept by an earlier guest form (or an older version of it) that the rules refuse -
    // under 18, in the future, before 1900 or not a real date - is discarded, never submitted.
    if (intent.birthday && !intent.birthdayApplied && window.ArchiveBirthday) {
      const usable = window.ArchiveBirthday.usableStashedBirthday(intent.birthday);

      if (usable) {
        intent.birthday = usable;
      } else {
        delete intent.birthday;
      }
    }

    const needsNewsletter = intent.newsletterOptIn === true && !intent.newsletterApplied;
    const needsBirthday = Boolean(intent.birthday) && !intent.birthdayApplied;

    if (!needsNewsletter && !needsBirthday) {
      window.localStorage.removeItem(guestIntentStorageKey);
      return;
    }

    let appliedSomething = false;

    if (needsNewsletter) {
      try {
        await updateNewsletterReward(true);
        intent.newsletterApplied = true;
        appliedSomething = true;
      } catch (error) {
        console.warn("Unable to apply stashed Archive Rewards newsletter opt-in.", error);
      }
    }

    if (needsBirthday) {
      try {
        await loadArchiveProfile();

        await saveArchiveProfile(intent.birthday);
        intent.birthdayApplied = true;
        appliedSomething = true;
      } catch (error) {
        // The server refused it (400: invalid, or a birthday is already saved): final - discard it
        // rather than retrying on every visit. A conflict, network or server failure keeps it for
        // the next visit.
        if (error && error.kind === "validation") {
          delete intent.birthday;
        } else {
          console.warn("Unable to apply stashed Archive Rewards birthday.", error);
        }
      }
    }

    const stillPending =
      (intent.newsletterOptIn === true && !intent.newsletterApplied) ||
      (Boolean(intent.birthday) && !intent.birthdayApplied);

    try {
      if (stillPending) {
        window.localStorage.setItem(guestIntentStorageKey, JSON.stringify(intent));
      } else {
        window.localStorage.removeItem(guestIntentStorageKey);
      }
    } catch (error) {
      console.warn("Unable to update stashed Archive Rewards guest intent.", error);
    }

    if (appliedSomething) {
      await loadRewardProfile();
    }
  }

  if (summaryElements.giftPreviousButton) {
    summaryElements.giftPreviousButton.addEventListener("click", () => {
      showGiftCarouselPage(giftCarouselPage - 1);
    });
  }

  if (summaryElements.giftNextButton) {
    summaryElements.giftNextButton.addEventListener("click", () => {
      showGiftCarouselPage(giftCarouselPage + 1);
    });
  }

  if (summaryElements.giftGrid) {
    const openGuestGiftSignIn = card => {
      window.location.href = card.dataset.guestGiftSignin || getCustomerLoginUrl();
    };

    summaryElements.giftGrid.addEventListener("click", event => {
      const addBirthdayButton = event.target instanceof Element
        ? event.target.closest("[data-rewards-add-birthday]")
        : null;

      const milestoneButton = event.target instanceof Element
        ? event.target.closest("[data-collector-milestone-learn-more]")
        : null;
      const guestGiftCard = event.target instanceof Element
        ? event.target.closest("[data-guest-gift-signin]")
        : null;

      if (milestoneButton) {
        event.preventDefault();
        openMilestoneRewardsInfoDialog();
        return;
      }

      if (guestGiftCard) {
        openGuestGiftSignIn(guestGiftCard);
        return;
      }

      if (addBirthdayButton) {
        openBirthdayDialog(addBirthdayButton.dataset.fallbackUrl);
      }
    });

    summaryElements.giftGrid.addEventListener("keydown", event => {
      if (event.key !== "Enter" && event.key !== " ") {
        return;
      }

      const guestGiftCard = event.target instanceof Element
        ? event.target.closest("[data-guest-gift-signin]")
        : null;

      if (!guestGiftCard) {
        return;
      }

      event.preventDefault();
      openGuestGiftSignIn(guestGiftCard);
    });
  }

  document.querySelectorAll("[data-gift-vouchers-modal-open]").forEach(control => {
    control.addEventListener("click", openGiftVouchersInfoDialog);
  });

  document.querySelectorAll("[data-milestone-rewards-modal-open]").forEach(control => {
    control.addEventListener("click", openMilestoneRewardsInfoDialog);
  });

  document.querySelectorAll("[data-milestone-rewards-modal-close]").forEach(control => {
    control.addEventListener("click", closeMilestoneRewardsInfoDialog);
  });

  window.addEventListener("resize", updateGiftCarousel);

  document.addEventListener("keydown", event => {
    if (
      event.key === "Escape" &&
      giftVouchersInfoDialog &&
      giftVouchersInfoDialog.classList.contains("is-open")
    ) {
      closeGiftVouchersInfoDialog();
    }

    if (
      event.key === "Escape" &&
      milestoneRewardsInfoDialog &&
      milestoneRewardsInfoDialog.classList.contains("is-open")
    ) {
      closeMilestoneRewardsInfoDialog();
    }
  });

  if (!customerConfig.isAuthenticated || !endpoint) {
    initializeGuestPreview();
    return;
  }

  if (summaryElements.convertButton) {
    summaryElements.convertButton.addEventListener("click", handleConvertClick);
  }

  if (summaryElements.voucherOptionsContainer) {
    summaryElements.voucherOptionsContainer.addEventListener("click", event => {
      const button = event.target instanceof Element
        ? event.target.closest("[data-rewards-generate-voucher]")
        : null;

      if (!button) {
        return;
      }

      handleGenerateClick({
        ...event,
        currentTarget: button
      });
    });
  }

  if (summaryElements.newsletterCheckbox) {
    summaryElements.newsletterCheckbox.addEventListener("change", handleNewsletterChange);
  }

  document.addEventListener("keydown", event => {
    if (
      event.key === "Escape" &&
      confirmDialog &&
      confirmDialog.classList.contains("is-open")
    ) {
      closeConfirmDialog(false);
    }

    if (
      event.key === "Escape" &&
      birthdayDialog &&
      birthdayDialog.classList.contains("is-open")
    ) {
      closeBirthdayDialog();
    }
  });

  window.archiveRewardsProfileLoadPromise = loadRewardProfile();
  window.archiveRewardsGuestIntentPromise =
    window.archiveRewardsProfileLoadPromise.then(() => applyStashedGuestIntent());
});

archiveRewardsReady(() => {
  function createPaginationButton(label, onClick, isDisabled) {
    const button = document.createElement("button");

    button.type = "button";
    button.textContent = label;
    button.disabled = Boolean(isDisabled);
    button.classList.add("archive-pagination__button");

    if (!isDisabled) {
      button.addEventListener("click", onClick);
    }

    return button;
  }

  function setupSimplePagination({ pagination, items, pageSize, onBeforePageChange }) {
    const totalPages = Math.max(1, Math.ceil(items.length / pageSize));
    let currentPage = 1;

    if (!pagination || items.length === 0) {
      return;
    }

    pagination.classList.add("archive-pagination--simple");

    function renderPagination() {
      pagination.replaceChildren(
        createPaginationButton("\u2190 Previous", () => showPage(currentPage - 1), currentPage === 1),
        createPaginationButton("Next \u2192", () => showPage(currentPage + 1), currentPage === totalPages)
      );
    }

    function showPage(page) {
      currentPage = Math.min(Math.max(page, 1), totalPages);

      const start = (currentPage - 1) * pageSize;
      const end = start + pageSize;

      if (onBeforePageChange) {
        onBeforePageChange(start);
      }

      items.forEach((item, index) => {
        item.hidden = index < start || index >= end;
      });

      renderPagination();
    }

    showPage(1);
  }

  const activityPagination = document.querySelector(".archive-activity-pagination");
  const activityPanel = activityPagination ? activityPagination.closest(".archive-rewards-panel") : null;
  const activityItems = activityPanel ? Array.from(activityPanel.querySelectorAll(".archive-activity-item")) : [];
  const activityConfig = window.archiveRewardsCustomer || {};
  const activityEndpoint = activityConfig.rewardTransactionsEndpoint;
  const activityReviewsEndpoint = activityEndpoint ? "/apps/archive/reviews/mine" : null;
  const activityList = activityPanel ? activityPanel.querySelector("[data-activity-list]") : null;
  const activitySearch = activityPanel ? activityPanel.querySelector("[data-activity-search]") : null;
  const activitySort = activityPanel ? activityPanel.querySelector("[data-activity-sort]") : null;
  const activityEmpty = activityPanel ? activityPanel.querySelector("[data-activity-empty]") : null;
  const activityPageSize = 5;
  const guestActivityTransactions = [
    {
      title: "Purchase reward earned",
      subtitle: "Order #1284",
      displayType: "purchase",
      icon: "purchase",
      amountCents: 650,
      createdAtUtc: "2026-07-11T09:15:00Z",
      orderNumber: "#1284",
      searchText: "purchase reward earned order 1284"
    },
    {
      title: "Review published: Springbank 15 Year Old",
      subtitle: "Reward earned",
      displayType: "review",
      icon: "review",
      amountCents: 200,
      createdAtUtc: "2026-07-09T06:40:00Z",
      productName: "Springbank 15 Year Old",
      searchText: "review published springbank 15 year old reward earned"
    },
    {
      title: "Birthday gift voucher issued",
      subtitle: "Birthday Gift",
      displayType: "birthday",
      icon: "birthday",
      amountCents: 1000,
      createdAtUtc: "2026-07-04T00:00:00Z",
      voucherCode: "BDAY-9Z7B-BXFG",
      searchText: "birthday gift voucher issued bday 9z7b bxfg"
    },
    {
      title: "Reward voucher redeemed",
      subtitle: "Order #1279",
      displayType: "voucher",
      icon: "voucher",
      amountCents: -1000,
      createdAtUtc: "2026-06-29T11:25:00Z",
      orderNumber: "#1279",
      voucherCode: "ARCHIVE-N5DC-7PWX",
      searchText: "reward voucher redeemed order 1279 archive n5dc 7pwx"
    },
    {
      title: "Collector milestone reached",
      subtitle: "$1,000 spend milestone",
      displayType: "milestone",
      icon: "milestone",
      amountCents: 2000,
      createdAtUtc: "2026-06-21T08:05:00Z",
      searchText: "collector milestone reached 1000 spend milestone"
    },
    {
      title: "Newsletter reward added",
      subtitle: "Newsletter subscription",
      displayType: "newsletter",
      icon: "newsletter",
      amountCents: 500,
      createdAtUtc: "2026-06-14T04:20:00Z",
      searchText: "newsletter reward added subscription"
    },
    {
      title: "Archive Profile completed",
      subtitle: "Profile reward",
      displayType: "profile",
      icon: "profile",
      amountCents: 500,
      createdAtUtc: "2026-06-10T02:30:00Z",
      searchText: "archive profile completed profile reward"
    },
    {
      title: "Promotional gift voucher issued",
      subtitle: "Founding Member Benefits",
      displayType: "promotion",
      icon: "promotion",
      amountCents: 1000,
      createdAtUtc: "2026-06-01T05:55:00Z",
      voucherCode: "PROMO-ZGAT-7LRE",
      searchText: "promotional gift voucher issued founding member benefits promo zgat 7lre"
    }
  ];
  let activityTransactions = [];
  let activityFilteredTransactions = [];
  let activityCurrentPage = 1;
  let activityOverflowFrame = null;
  let activityResizeObserver = null;
  let activityReviewProductNames = new Map();

  function escapeActivityHtml(value) {
    return String(value ?? "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function readActivityField(transaction, camelName, pascalName) {
    return transaction?.[camelName] ?? transaction?.[pascalName];
  }

  function formatActivityDate(value) {
    if (!value) {
      return "";
    }

    const date = new Date(value);

    if (Number.isNaN(date.getTime())) {
      return "";
    }

    return new Intl.DateTimeFormat("en-AU", {
      day: "2-digit",
      month: "short",
      year: "numeric"
    }).format(date);
  }

  function formatActivityPoints(value) {
    const amount = Number(value) || 0;
    const prefix = amount > 0 ? "+" : "";

    return `${prefix}${new Intl.NumberFormat("en-AU").format(amount)}`;
  }

  function getActivityIcon(displayType) {
    const type = String(displayType || "reward").toLowerCase();

    if (type === "voucher") {
      return `
        <path d="M5 9h14v2a2 2 0 010 4v2H5v-2a2 2 0 010-4V9z"></path>
        <path d="M12 9v8"></path>
      `;
    }

    if (type === "birthday" || type === "anniversary" || type === "promotion") {
      return `
        <rect x="4" y="10" width="16" height="10" rx="1.5"></rect>
        <path d="M12 10v10"></path>
        <path d="M4 14h16"></path>
        <path d="M12 10c-1.5 0-3-1.2-3-2.8C9 5.8 10.1 5 11.2 5c1 0 1.6.7.8 5z"></path>
        <path d="M12 10c1.5 0 3-1.2 3-2.8C15 5.8 13.9 5 12.8 5c-1 0-1.6.7-.8 5z"></path>
      `;
    }

    if (type === "milestone") {
      return `
        <path d="M8 5h8v3.5a4 4 0 01-8 0V5z"></path>
        <path d="M8 7H5.5a2.5 2.5 0 002.7 3"></path>
        <path d="M16 7h2.5a2.5 2.5 0 01-2.7 3"></path>
        <path d="M12 13v4"></path>
        <path d="M9 19h6"></path>
      `;
    }

    if (type === "purchase") {
      return `
        <path d="M6 7h12l-1.2 9H7.2L6 7z"></path>
        <path d="M9 7a3 3 0 016 0"></path>
      `;
    }

    if (type === "review") {
      return `
        <path d="M12 3.5l2.3 5 5.4.7-4 3.8 1 5.4L12 15.8l-4.7 2.6 1-5.4-4-3.8 5.4-.7L12 3.5z"></path>
      `;
    }

    if (type === "newsletter") {
      return `
        <rect x="4" y="6" width="16" height="12" rx="1.5"></rect>
        <path d="M5 8l7 5 7-5"></path>
      `;
    }

    if (type === "profile") {
      return `
        <circle cx="12" cy="8" r="3"></circle>
        <path d="M6.5 19a5.5 5.5 0 0111 0"></path>
      `;
    }

    return `
      <rect x="4" y="10" width="16" height="10" rx="1.5"></rect>
      <path d="M12 10v10"></path>
      <path d="M4 14h16"></path>
      <path d="M12 10c-1.5 0-3-1.2-3-2.8C9 5.8 10.1 5 11.2 5c1 0 1.6.7.8 5z"></path>
      <path d="M12 10c1.5 0 3-1.2 3-2.8C15 5.8 13.9 5 12.8 5c-1 0-1.6.7-.8 5z"></path>
    `;
  }

  function normaliseChallengeTier(value) {
    const match = String(value || "").trim().match(/^(explorer|collector|archivist)$/i);
    if (!match) {
      return "";
    }

    return match[1].charAt(0).toUpperCase() + match[1].slice(1).toLowerCase();
  }

  function getChallengeTier(transaction) {
    const explicitTier = normaliseChallengeTier(
      readActivityField(transaction, "challengeTier", "ChallengeTier") ||
      readActivityField(transaction, "challengeType", "ChallengeType") ||
      readActivityField(transaction, "tier", "Tier")
    );

    if (explicitTier) {
      return explicitTier;
    }

    const safeDescription = String(
      readActivityField(transaction, "subtitle", "Subtitle") ||
      readActivityField(transaction, "description", "Description") ||
      ""
    ).trim();
    const safeDescriptionMatch = safeDescription.match(
      /^Archive Challenge reward\s*[—-]\s*(Explorer|Collector|Archivist)\.?$/i
    );

    return normaliseChallengeTier(safeDescriptionMatch?.[1]);
  }

  function getCustomerActivityPresentation(transaction) {
    const title = readActivityField(transaction, "title", "Title") || "Reward activity";
    const displayType = String(
      readActivityField(transaction, "icon", "Icon") ||
      readActivityField(transaction, "displayType", "DisplayType") ||
      ""
    ).toLowerCase();
    const referenceType = String(
      readActivityField(transaction, "referenceType", "ReferenceType") ||
      ""
    ).toLowerCase();

    if (referenceType === "engagelychallenge") {
      const tier = getChallengeTier(transaction);
      return {
        title,
        subtitle: "Archive Challenge reward",
        context: tier ? `${tier} Challenge` : "",
        showContextAlways: Boolean(tier)
      };
    }

    if (displayType === "review" || referenceType === "review") {
      const referenceId = String(
        readActivityField(transaction, "referenceId", "ReferenceId") ||
        ""
      ).trim();
      const productName = String(
        readActivityField(transaction, "productName", "ProductName") ||
        activityReviewProductNames.get(referenceId) ||
        ""
      ).trim();
      return {
        title,
        subtitle: "Review reward",
        context: productName,
        showContextAlways: Boolean(productName)
      };
    }

    const subtitle = readActivityField(transaction, "subtitle", "Subtitle") ||
      readActivityField(transaction, "description", "Description") ||
      "";
    return {
      title,
      subtitle,
      context: subtitle,
      showContextAlways: false
    };
  }

  function renderActivityTransaction(transaction, index) {
    const presentation = getCustomerActivityPresentation(transaction);
    const title = presentation.title;
    const subtitle = presentation.subtitle;
    const context = presentation.context;
    const displayType = readActivityField(transaction, "icon", "Icon") ||
      readActivityField(transaction, "displayType", "DisplayType") ||
      "reward";
    const amount = Number(readActivityField(transaction, "amountCents", "AmountCents")) || 0;
    const createdAt = readActivityField(transaction, "createdAtUtc", "CreatedAtUtc");
    const isNegative = amount < 0;
    const iconClass = index % 2 === 0 ? "archive-activity-icon--dark" : "archive-activity-icon--gold";
    const descriptionId = `archiveActivityDescription-${activityCurrentPage}-${index}`;

    return `
      <div class="archive-activity-item" data-activity-item>
        <div class="archive-activity-icon ${iconClass}">
          <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
            ${getActivityIcon(displayType)}
          </svg>
        </div>
        <div class="archive-activity-details">
          <strong>${escapeActivityHtml(title)}</strong>
          ${subtitle ? `
            <div class="archive-activity-description" data-activity-description>
              <p data-activity-description-text>${escapeActivityHtml(subtitle)}</p>
              <button
                type="button"
                class="archive-activity-description__toggle"
                data-activity-description-toggle
                ${presentation.showContextAlways ? "data-activity-description-context" : ""}
                data-activity-description-has-context="${context ? "true" : "false"}"
                aria-expanded="false"
                aria-describedby="${descriptionId}"
                hidden
              >See more</button>
              <span
                id="${descriptionId}"
                class="archive-activity-description__popover"
                role="tooltip"
                aria-hidden="true"
              >
                <button
                  type="button"
                  class="archive-activity-description__close"
                  data-activity-description-close
                  aria-label="Close"
                >&times;</button>
                ${escapeActivityHtml(context)}
              </span>
            </div>
          ` : ""}
        </div>
        <div class="archive-activity-points${isNegative ? " negative" : ""}">
          ${escapeActivityHtml(formatActivityPoints(amount))}
          <span>Points</span>
        </div>
        <time datetime="${escapeActivityHtml(createdAt || "")}">${escapeActivityHtml(formatActivityDate(createdAt))}</time>
      </div>
    `;
  }

  function closeActivityDescription(container) {
    if (!container) {
      return;
    }

    container.classList.remove("is-open");
    const toggle = container.querySelector("[data-activity-description-toggle]");
    toggle?.setAttribute("aria-expanded", "false");
  }

  function activityUsesTouchPopover() {
    return !window.matchMedia("(hover: hover) and (pointer: fine)").matches;
  }

  function updateActivityDescriptionOverflow() {
    if (!activityList) {
      return;
    }

    activityList.querySelectorAll("[data-activity-description]").forEach(container => {
      const text = container.querySelector("[data-activity-description-text]");
      const toggle = container.querySelector("[data-activity-description-toggle]");
      const popover = container.querySelector(".archive-activity-description__popover");

      if (!text || !toggle) {
        return;
      }

      toggle.hidden = true;
      container.classList.remove("is-truncated");
      closeActivityDescription(container);

      const isTruncated = text.scrollWidth > text.clientWidth + 1;
      const hasDedicatedContext = toggle.hasAttribute("data-activity-description-context");
      const hasSafeContext = toggle.getAttribute("data-activity-description-has-context") === "true";
      toggle.hidden = !hasSafeContext || (!hasDedicatedContext && !isTruncated);
      container.classList.toggle("is-truncated", isTruncated);
      popover?.setAttribute("aria-hidden", String(toggle.hidden));
    });
  }

  function scheduleActivityOverflowUpdate() {
    window.cancelAnimationFrame(activityOverflowFrame);
    activityOverflowFrame = window.requestAnimationFrame(() => {
      activityOverflowFrame = null;
      updateActivityDescriptionOverflow();
    });
  }

  function getActivitySearchText(transaction) {
    const presentation = getCustomerActivityPresentation(transaction);
    return [
      presentation.title,
      presentation.subtitle,
      presentation.context,
      readActivityField(transaction, "productName", "ProductName"),
      readActivityField(transaction, "voucherCode", "VoucherCode"),
      readActivityField(transaction, "orderNumber", "OrderNumber")
    ].filter(Boolean).join(" ").toLowerCase();
  }

  function applyActivityFilters() {
    const query = activitySearch ? activitySearch.value.trim().toLowerCase() : "";
    const sort = activitySort ? activitySort.value : "newest";

    activityFilteredTransactions = activityTransactions
      .filter(transaction => !query || getActivitySearchText(transaction).includes(query))
      .sort((left, right) => {
        const leftDate = new Date(readActivityField(left, "createdAtUtc", "CreatedAtUtc") || 0).getTime();
        const rightDate = new Date(readActivityField(right, "createdAtUtc", "CreatedAtUtc") || 0).getTime();

        return sort === "oldest"
          ? leftDate - rightDate
          : rightDate - leftDate;
      });

    activityCurrentPage = 1;
    renderActivityPage();
  }

  function renderActivityPagination(totalPages) {
    if (!activityPagination) {
      return;
    }

    activityPagination.classList.add("archive-pagination--simple");
    activityPagination.replaceChildren(
      createPaginationButton("\u2190 Previous", () => {
        activityCurrentPage = Math.max(1, activityCurrentPage - 1);
        renderActivityPage();
      }, activityCurrentPage === 1),
      createPaginationButton("Next \u2192", () => {
        activityCurrentPage = Math.min(totalPages, activityCurrentPage + 1);
        renderActivityPage();
      }, activityCurrentPage === totalPages)
    );
  }

  function renderActivityPage() {
    if (!activityList) {
      return;
    }

    const totalPages = Math.max(1, Math.ceil(activityFilteredTransactions.length / activityPageSize));
    const start = (activityCurrentPage - 1) * activityPageSize;
    const pageItems = activityFilteredTransactions.slice(start, start + activityPageSize);

    activityList.classList.remove("archive-activity-list--loading");
    activityList.classList.add("archive-activity-list--loaded");
    activityList.innerHTML = pageItems.map(renderActivityTransaction).join("");
    scheduleActivityOverflowUpdate();

    if (activityEmpty) {
      activityEmpty.hidden = pageItems.length > 0;

      const title = activityEmpty.querySelector("strong");
      const copy = activityEmpty.querySelector("p");

      if (title && copy) {
        title.textContent = activityTransactions.length === 0
          ? "No reward activity yet"
          : "No matching activity";
        copy.textContent = activityTransactions.length === 0
          ? "Complete your Archive Profile, subscribe to the newsletter, make a purchase or publish a review to begin your rewards ledger."
          : "Try a different search term or switch the sort order to explore your rewards ledger.";
      }
    }

    renderActivityPagination(totalPages);
  }

  if (activityList) {
    activityList.addEventListener("click", event => {
      const close = event.target.closest("[data-activity-description-close]");
      if (close) {
        closeActivityDescription(close.closest("[data-activity-description]"));
        return;
      }

      const toggle = event.target.closest("[data-activity-description-toggle]");
      if (!toggle) {
        return;
      }

      const container = toggle.closest("[data-activity-description]");

      if (!activityUsesTouchPopover() || event.detail === 0) {
        closeActivityDescription(container);
        return;
      }

      const willOpen = !container.classList.contains("is-open");

      activityList.querySelectorAll("[data-activity-description].is-open").forEach(openContainer => {
        if (openContainer !== container) {
          closeActivityDescription(openContainer);
        }
      });

      container.classList.toggle("is-open", willOpen);
      toggle.setAttribute("aria-expanded", String(willOpen));
    });

    activityList.addEventListener("keydown", event => {
      if (event.key !== "Escape") {
        return;
      }

      const container = event.target.closest("[data-activity-description].is-open");
      if (!container) {
        return;
      }

      closeActivityDescription(container);
      container.querySelector("[data-activity-description-toggle]")?.focus();
    });

    if (typeof ResizeObserver !== "undefined") {
      activityResizeObserver = new ResizeObserver(scheduleActivityOverflowUpdate);
      activityResizeObserver.observe(activityList);
    } else {
      window.addEventListener("resize", scheduleActivityOverflowUpdate);
    }
  }

  async function loadRecentActivity() {
    if (!activityList) {
      return;
    }

    if (!activityEndpoint) {
      activityTransactions = guestActivityTransactions;
      applyActivityFilters();
      return;
    }

    try {
      const initializationPromise =
        window.archiveRewardsGuestIntentPromise ||
        window.archiveRewardsProfileLoadPromise;

      if (initializationPromise) {
        await initializationPromise;
      }

      const fetchActivityPage = async page => {
        const response = await fetch(`${activityEndpoint}?page=${page}&pageSize=100`, {
          method: "GET",
          credentials: "same-origin",
          headers: {
            Accept: "application/json"
          }
        });

        if (!response.ok) {
          throw new Error("Recent activity request failed.");
        }

        return response.json();
      };

      const payload = await fetchActivityPage(1);
      const totalPages = Number(payload.totalPages || payload.TotalPages) || 1;
      const remainingPayloads = totalPages > 1
        ? await Promise.all(
          Array.from({ length: totalPages - 1 }, (_, index) => fetchActivityPage(index + 2))
        )
        : [];

      activityTransactions = [payload, ...remainingPayloads].flatMap(pagePayload =>
        pagePayload.transactions || pagePayload.Transactions || []
      );

      activityReviewProductNames = new Map();
      const needsReviewLookup = activityTransactions.some(transaction => {
        const displayType = String(
          readActivityField(transaction, "icon", "Icon") ||
          readActivityField(transaction, "displayType", "DisplayType") ||
          ""
        ).toLowerCase();
        const referenceType = String(
          readActivityField(transaction, "referenceType", "ReferenceType") || ""
        ).toLowerCase();
        const productName = readActivityField(transaction, "productName", "ProductName");
        const referenceId = readActivityField(transaction, "referenceId", "ReferenceId");

        return (displayType === "review" || referenceType === "review") &&
          !String(productName || "").trim() &&
          Boolean(String(referenceId || "").trim());
      });

      if (activityReviewsEndpoint && needsReviewLookup) {
        try {
          const reviewsResponse = await fetch(activityReviewsEndpoint, {
            method: "GET",
            credentials: "same-origin",
            headers: {
              Accept: "application/json"
            }
          });

          if (reviewsResponse.ok) {
            const reviewsPayload = await reviewsResponse.json();
            const reviews = reviewsPayload.reviews || reviewsPayload.Reviews || [];
            reviews.forEach(review => {
              const reviewId = String(
                readActivityField(review, "reviewId", "ReviewId") || ""
              ).trim();
              const productName = String(
                readActivityField(review, "productName", "ProductName") ||
                readActivityField(review, "productTitle", "ProductTitle") ||
                ""
              ).trim();

              if (reviewId && productName) {
                activityReviewProductNames.set(reviewId, productName);
              }
            });
          }
        } catch (error) {
          activityReviewProductNames = new Map();
        }
      }

      applyActivityFilters();
    } catch (error) {
      activityTransactions = [];
      activityFilteredTransactions = [];
      renderActivityPage();
    }
  }

  if (activitySearch) {
    activitySearch.addEventListener("input", applyActivityFilters);
  }

  if (activitySort) {
    activitySort.addEventListener("change", applyActivityFilters);
  }

  loadRecentActivity();

  const faqPagination = document.querySelector(".archive-faq-pagination");
  const faqPanel = faqPagination ? faqPagination.closest(".archive-rewards-panel") : null;
  const faqs = faqPanel ? Array.from(faqPanel.querySelectorAll("details")) : [];

  function closeFaqs() {
    faqs.forEach(faq => {
      faq.removeAttribute("open");
    });
  }

  if (!faqPanel || !faqPagination || faqs.length === 0) {
    return;
  }

  faqs.forEach(faq => {
    const summary = faq.querySelector("summary");

    if (!summary) {
      return;
    }

    summary.addEventListener("click", () => {
      faqs.forEach(other => {
        if (other !== faq) {
          other.removeAttribute("open");
        }
      });
    });
  });

  setupSimplePagination({
    pagination: faqPagination,
    items: faqs,
    pageSize: 5,
    onBeforePageChange: start => {
      closeFaqs();

      faqs.forEach((faq, index) => {
        faq.classList.toggle("archive-faq-page-first", index === start);
      });
    }
  });
});

archiveRewardsReady(() => {
  const modal = document.getElementById("archiveRewardsHowItWorks");
  const openButtons = Array.from(document.querySelectorAll("[data-archive-rewards-modal-open]"));
  const closeButtons = document.querySelectorAll("[data-archive-rewards-modal-close]");
  let activeOpenButton = null;

  if (!modal || openButtons.length === 0) {
    return;
  }

  function openModal(event) {
    event.preventDefault();
    activeOpenButton = event.currentTarget;
    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");
    document.body.classList.add("archive-rewards-modal-open");
  }

  function closeModal() {
    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden", "true");
    document.body.classList.remove("archive-rewards-modal-open");

    if (activeOpenButton) {
      activeOpenButton.focus();
    }
  }

  openButtons.forEach(button => {
    button.addEventListener("click", openModal);
  });

  closeButtons.forEach(button => {
    button.addEventListener("click", closeModal);
  });

  modal.addEventListener("click", event => {
    if (event.target === modal || event.target.classList.contains("archive-rewards-modal__backdrop")) {
      closeModal();
    }
  });

  document.addEventListener("click", event => {
    const dialog = modal.querySelector(".archive-rewards-modal__dialog");

    if (
      modal.classList.contains("is-open") &&
      dialog &&
      !dialog.contains(event.target) &&
      !openButtons.includes(event.target)
    ) {
      closeModal();
    }
  });

  document.addEventListener("keydown", event => {
    if (event.key === "Escape" && modal.classList.contains("is-open")) {
      closeModal();
    }
  });
});

archiveRewardsReady(() => {
  function showCopyToast() {
    window.archiveRewardsShowToast({
      title: "Voucher code copied",
      message: "Ready to use at checkout."
    });
  }

  function fallbackCopy(text) {
    const textarea = document.createElement("textarea");

    textarea.value = text;
    textarea.setAttribute("readonly", "");
    textarea.style.position = "fixed";
    textarea.style.top = "0";
    textarea.style.left = "-9999px";

    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand("copy");
    textarea.remove();
  }

  async function copyCode(code) {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(code);
    } else {
      fallbackCopy(code);
    }

    showCopyToast();
  }

  function handleCopy(event) {
    const control = event.currentTarget;
    const code = control.dataset.copyCode;

    if (!code) {
      return;
    }

    copyCode(code).catch(() => {
      fallbackCopy(code);
      showCopyToast();
    });
  }

  function getCopyControl(target) {
    return target instanceof Element
      ? target.closest("[data-copy-code]")
      : null;
  }

  document.addEventListener("click", event => {
    const control = getCopyControl(event.target);

    if (!control) {
      return;
    }

    handleCopy({
      currentTarget: control
    });
  });

  document.addEventListener("keydown", event => {
    const control = getCopyControl(event.target);

    if (
      !control ||
      control.matches("button, a") ||
      (event.key !== "Enter" && event.key !== " ")
    ) {
      return;
    }

    event.preventDefault();
    handleCopy({
      currentTarget: control
    });
  });
});
